/* TOPNAVI — termék-popup viselkedés (2026-09-06)
   A snippets/product-popup.liquid inline <script> blokkjai (1,3,4,5) — cache-elhető
   külső fájlba költöztetve. A fordítások és a terméknév a snippet inline
   window.TNPP objektumából jönnek (Liquid ott marad). A 2. blokk (garancia/
   kiegészítő-konfig) 2026-09-23 óta szintén itt van — az adata a snippet window.TNPP2 objektuma. */

/* ===== blokk 2 (2026-09-23, perf-4): garancia-hosszabbítás, kiegészítő-ajánló v2, kosárba-folyamat, Q7-dekóder.
   Korábban inline a snippets/product-popup.liquid-ben (~65 KB minden terméklapon). A Liquid-adat a snippet window.TNPP2
   objektumában van; a snippet inline csonkja hívja meg DOMContentLoaded-kor a RÉGI helyén, így a DCL-kezelők sorrendje
   (a capture-fázisú Kosárba-elfogás elsőbbsége is) változatlan. ===== */
window.__tnPP2 = function () {
    const C = window.TNPP2 || { t: {} };
    // ---- KONFIGURÁCIÓ ----
    const POPUP_ENABLED = true;
    const KEDVEZMENY_KOD = ""; //most nincs kedvezmény

    // Metafield értéke (Liquid injection). Default: true (megjeleníthető), ha nincs beállítva.
    // Figyelem: A liquid output 'true'/'false' szövegként kerül be, de JS boolean-ként értelmezzük.
    // Ha a metafield 'false', akkor ELREJTJÜK. Minden más esetben (true, null, undefined) MEGJELENÍTJÜK.
    const DISPLAY_RCA_AMP = C.rcaAmp;

    /* 2026-09-15: melyik fejegység-változatnál ajánljuk a hosszabbítást — a TopApp dönti el (shop.metafields.topapp.warranty); null = eddigi (ELITE-től) */
    window.TN_WARRANTY_TIERS = C.wt;
    // --- WARRANTY CONFIGURATION (DYNAMIC) — a garancia-termék élő variánsárai a snippetből (C.wp), különben a lenti statikus tartalék ---

    const warranty_map = {
        "PRO": { "1y": 53399405527380, "2y": 53399405560148 },
        "ELITE": { "1y": 53399405592916, "2y": 53399405625684 },
        "PREMIUM": { "1y": 53399405658452, "2y": 53399405691220 },
        "PRÉMIUM": { "1y": 53399405658452, "2y": 53399405691220 },
        "PRÉMIUM+": { "1y": 53399405723988, "2y": 53399405756756 }
    };

    // 2026-09-04: `= {}` helyett `= ... || {}` — így ez a blokk SOSEM törli ki a
    // már beállított konfigurációt (a cart-template.liquid statikus tartaléka).
    window.WARRANTY_CONFIG = window.WARRANTY_CONFIG || {};

    /* 2026-09-23 (jogi átnézés): 250 000 Ft FELETTI változatnál a kötelező jótállás 3 év (151/2003. Korm. r.) — az ablak ebből számolja az alapot és az összesent. */
    window.TN_W3Y = C.w3y || { "0": 0 };

    if (C.wp && C.wp.length) {
       // Map variant IDs to prices (in cents) and formatted strings
       const variantPrices = {};
       const variantFormattedPrices = {};
       C.wp.forEach((r) => { variantPrices[r[0]] = r[1]; variantFormattedPrices[r[0]] = r[2]; });

       // Build the config
       for (const [level, opts] of Object.entries(warranty_map)) {
           // 2026-09-04: csak akkor állítjuk be a szintet, ha MINDKÉT variáns ára
           // megjött. Különben az adott szint marad a korábbi (statikus) értékein,
           // és nem jelenik meg „+0 Ft" a garancia-választóban.
           if (!variantPrices[opts["1y"]] || !variantPrices[opts["2y"]]) continue;
           window.WARRANTY_CONFIG[level] = {
               "1y": { 
                   id: opts["1y"], 
                   price: variantPrices[opts["1y"]] || 0,
                   formatted_price: variantFormattedPrices[opts["1y"]] || ""
               }, 
               "2y": { 
                   id: opts["2y"], 
                   price: variantPrices[opts["2y"]] || 0,
                   formatted_price: variantFormattedPrices[opts["2y"]] || ""
               }
           };
       }
       console.log("Dynamic Warranty Config Loaded:", window.WARRANTY_CONFIG);
    } else {
       console.warn("Warranty product not found via Liquid search. Fallback to static prices.");
       window.WARRANTY_CONFIG = {
            "PRO": { "1y": { id: 53399405527380, price: 1299000 }, "2y": { id: 53399405560148, price: 1699000 } },
            "ELITE": { "1y": { id: 53399405592916, price: 1499000 }, "2y": { id: 53399405625684, price: 1899000 } },
            "PREMIUM": { "1y": { id: 53399405658452, price: 1899000 }, "2y": { id: 53399405691220, price: 2299000 } },
            "PRÉMIUM": { "1y": { id: 53399405658452, price: 1899000 }, "2y": { id: 53399405691220, price: 2299000 } },
            "PRÉMIUM+": { "1y": { id: 53399405723988, price: 1899000 }, "2y": { id: 53399405756756, price: 2299000 } }
       };
    }

    // Aktuális pénznem lekérése Shopify-ból
    const activeCurrency = C.cur;

    let ACCESSORIES_DATA = [
        {
            "id": "51783327023444", "title": C.t.acc_cam_title, "description": C.t.acc_cam_desc, "image_url": "https://www.topnavi.hu/cdn/shop/files/univerzalis-tolatokamera-669433_1024x1024.webp?v=1746073431",
            "prices": { "HUF": 14990, "EUR": 38, "RON": 190, "PLN": 170 }, "sale_price": null, "discount_percentage": null
        },
        {
            "id": "51263915295060", "title": C.t.acc_antenna_title, "description": C.t.acc_antenna_desc, "image_url": "https://www.topnavi.hu/cdn/shop/files/antenna-erosito-597766_270x270.jpg?v=1744114288",
            "prices": { "HUF": 9990, "EUR": 25, "RON": 126, "PLN": 110 }, "sale_price": null, "discount_percentage": null
        },
        {
            "id": "51089474683220", "title": C.t.acc_trim_title, "description": C.t.acc_trim_desc, "image_url": "https://www.topnavi.hu/cdn/shop/files/muanyag-patent-kiszedo-multimediahoz-461801_270x270.jpg?v=1744114291",
            "prices": { "HUF": 1990, "EUR": 5, "RON": 25, "PLN": 20 }, "sale_price": null, "discount_percentage": null
        },
        {
            "id": "51171565207892", "title": C.t.acc_obd_title, "description": C.t.acc_obd_desc, "image_url": "https://www.topnavi.hu/cdn/shop/files/obd-2-bluetooth-autodiagnosztika-882199_270x270.jpg?v=1744114278",
            "prices": { "HUF": 9990, "EUR": 25, "RON": 126, "PLN": 110 }, "sale_price": null, "discount_percentage": null
        },
        {
            "id": "51171627565396", "title": C.t.acc_dashcam_title, "description": C.t.acc_dashcam_desc, "image_url": "https://www.topnavi.hu/cdn/shop/files/menetrogzito-kamera-dashcam-860842_270x270.jpg?v=1744114286",
            "prices": { "HUF": 9990, "EUR": 25, "RON": 126, "PLN": 110 }, "sale_price": null, "discount_percentage": null
        },
        
    ];

    // Szűrés a metafield alapján
    if (DISPLAY_RCA_AMP === true) {
        // Ha hamis, kivesszük az RCA-t (51171571532116) és az Antenna Erősítőt (51263915295060)
        ACCESSORIES_DATA = ACCESSORIES_DATA.filter(item => item.id !== "51171571532116" && item.id !== "51263915295060");
    }
    /* HIDE MIC + ANTENNA — variánsfüggő (custom.freemic_variant). A/B/C/NONE szabály.
       NONE (üres variáns VAGY üres kupon-mező) → semmi nem rejtődik, mic+antenna
       fizetős upsell marad. FONTOS: blokk-komment, NEM sor-komment — a Liquid
       whitespace-strip miatt a const ugyanarra a sorra kerülhet a kommenttel. */
    const FREEMIC_VARIANT = C.fmv;
    const FREEMIC_ACTIVE  = C.fma;
    const MIC_ID = "51064671338836";
    const STD_ANTENNA_ID = "51263915295060";
    const HIDE_RULES = {
        A: [MIC_ID, STD_ANTENNA_ID],  // mindkettő ajándék → elrejt
        B: [MIC_ID],                  // csak mic ajándék → std antenna fizetős marad
        C: [MIC_ID, STD_ANTENNA_ID]   // mic + alt antenna ajándék → std antenna sem ajánlható
    };
    const _hideIds = (FREEMIC_ACTIVE && HIDE_RULES[FREEMIC_VARIANT]) ? HIDE_RULES[FREEMIC_VARIANT] : [];
    if (_hideIds.length) {
        ACCESSORIES_DATA = ACCESSORIES_DATA.filter(item => !_hideIds.includes(item.id));
    }
    const RCA_ID = "51171571532116";

    if (!POPUP_ENABLED) return;

    let isBuyNowFlow = false;
    const selectedAccessoryIds = new Set();
    const swipers = {};

    const getSelectedProductVersion = () => {
        const checkedElements = document.querySelectorAll('.swatch-element input[type="radio"]:checked');
        for (const el of checkedElements) {
            const version = el.closest('.swatch-element').getAttribute('version');
            if (version) return version.toUpperCase();
        }
        return null;
    };
    
    // Számformázás adott valutához
    // Note: ha a currency nem támogatott normálisan (pl lej), beállítható itt fallback
    const formatCurrency = (amount, currencyCode) => {
        // Formázás nyelv és pénznem szerint
        let locale = 'hu-HU';
        if (currencyCode === 'EUR') locale = 'en-DE'; // Tizedesjegyek és ezer elválasztók miatt
        if (currencyCode === 'RON') locale = 'ro-RO';
        
        return new Intl.NumberFormat(locale, { 
            style: 'currency', 
            currency: currencyCode, 
            minimumFractionDigits: (currencyCode === 'HUF' || currencyCode === 'RON') ? 0 : 2, 
            maximumFractionDigits: (currencyCode === 'HUF' || currencyCode === 'RON') ? 0 : 2
        }).format(amount);
    };
    
    const handleMicDependency = (popup) => {
        const version = getSelectedProductVersion();
        const micButton = popup.querySelector(`.add-accessory-btn[data-id="${MIC_ID}"]`);
        if (!micButton) return;

        const isPremium = ["PRO", "ELITE", "PRÉMIUM", "PRÉMIUM+"].includes(version);
        const rcaIsIncluded = isPremium;
        const rcaIsSelected = selectedAccessoryIds.has(RCA_ID);
        
        const canAddMic = rcaIsIncluded || rcaIsSelected;
        micButton.disabled = !canAddMic;
        
        if (canAddMic) {
            if (!selectedAccessoryIds.has(MIC_ID)) micButton.textContent = C.t.add_btn;
        } else {
            micButton.textContent = C.t.rca_required;
        }
    };
    
    const setupAccessoryListeners = (popup) => {
        popup.querySelectorAll('.add-accessory-btn').forEach(btn => {
            btn.onclick = (e) => {
                e.preventDefault();
                e.stopPropagation(); // Stop Swiper click hijacking
                
                if (e.currentTarget.disabled) return;
                const id = e.currentTarget.getAttribute('data-id');
                const swiper = swipers[popup.id];
                
                if (selectedAccessoryIds.has(id)) {
                    selectedAccessoryIds.delete(id);
                    e.currentTarget.textContent = C.t.add_btn.toUpperCase();
                    e.currentTarget.classList.remove('added');
                } else {
                    selectedAccessoryIds.add(id);
                    e.currentTarget.textContent = C.t.added_btn.toUpperCase();
                    e.currentTarget.classList.add('added');
                    if (swiper && !swiper.isEnd) setTimeout(() => { swiper.slideNext(); }, 250);
                }
                handleMicDependency(popup);
            };
        });
        // Handle Bundle Buttons
        popup.querySelectorAll('.add-bundle-btn').forEach(btn => {
            btn.onclick = (e) => {
                e.preventDefault();
                e.stopPropagation();

                const ids = e.currentTarget.getAttribute('data-bundle-ids').split(',');
                const coupon = e.currentTarget.getAttribute('data-coupon');
                const isSelected = e.currentTarget.classList.contains('added');
                const swiper = swipers[popup.id]; // Get Swiper instance

                if (isSelected) {
                    // Remove Bundle
                    ids.forEach(id => selectedAccessoryIds.delete(id));
                    
                    e.currentTarget.textContent = C.t.add_btn.toUpperCase();
                    e.currentTarget.classList.remove('added');
                    e.currentTarget.style.removeProperty('background-color'); // Remove inline override
                    e.currentTarget.style.removeProperty('border-color');
                    
                    if (window.KEDVEZMENY_KOD === coupon) window.KEDVEZMENY_KOD = null;
                } else {
                    // Add Bundle
                    ids.forEach(id => selectedAccessoryIds.add(id));
                    
                    e.currentTarget.textContent = '✅ ' + C.t.added_btn.toUpperCase(); 
                    e.currentTarget.classList.add('added');
                    // We let CSS .added class handle the green color if possible. 
                    // If CSS is weak, we keep the inline style but be consistent.
                    e.currentTarget.style.background = '#28a745'; 
                    
                    if (coupon) window.KEDVEZMENY_KOD = coupon;
                    
                    // Auto-scroll logic
                    if (swiper && !swiper.isEnd) {
                        setTimeout(() => { swiper.slideNext(); }, 250);
                    }
                }
                handleMicDependency(popup);
            };
        });

        handleMicDependency(popup);
    };

    const initSwiper = (popup) => {
        // 2026-07-12 (H12): a Swiper a theme.liquid-ből jön (swiper@11, defer);
        // ha valamiért még nem töltődött be, csendben kihagyjuk az initet.
        if (typeof Swiper === 'undefined') return;
        if (swipers[popup.id]) swipers[popup.id].destroy(true, true);
        swipers[popup.id] = new Swiper(popup.querySelector('.swiper-container'), {
            slidesPerView: 'auto',
            spaceBetween: 15,
            centeredSlides: true,
            // FONTOS: a popup `display:none` állapotban inicializálódik, ezért
            // observer + observeParents kell, hogy mikor láthatóvá válik, Swiper
            // újraszámolja a slide-szélességet és a translateX-et. Mobilon ettől
            // jelentek meg eddig elcsúszva a kártyák.
            observer: true,
            observeParents: true,
            observeSlideChildren: true,
            pagination: { el: popup.querySelector('.swiper-pagination'), clickable: true },
            navigation: { nextEl: popup.querySelector('.swiper-button-next'), prevEl: popup.querySelector('.swiper-button-prev')}
        });
    };


    /* ══════════════════════════════════════════════════════════════════
       KIEGÉSZÍTŐ-AJÁNLÓ v2 (2026-09-15) — TopApp-vezérelt, változatonként más
       ──────────────────────────────────────────────────────────────────
       · Forrás: snippets/tn-acc-data.liquid (a TopApp napi rangsora a bolt
         metamezőjéből, CSAK készleten lévő változatok). Ha nincs adat, a fenti
         ACCESSORIES_DATA a tartalék.
       · Szelet = a kiválasztott fejegység-változat (alap…premium_plus, default).
       · Mérés: megjelenés / hozzáadás / kivétel / továbblépés / kihagyás
         sendBeacon-nal a TopAppnak (app.topnavi.hu/accessory/event) — véletlen
         munkamenet-azonosító, süti és személyes adat nélkül. Ebből dől el a sorrend.
       · A popupból kosárba tett kiegészítő `_tn_acc` rejtett tulajdonságot kap
         (a rendelésből így mérhető, mennyit ad el a popup).
       · Kedvezmény: a TopApp automatikus Shopify-kedvezménye adja a kosárban;
         itt csak megmutatjuk (áthúzott ár + „-1 000 Ft a készülék mellé” — kerek forint, százalék nélkül).
       ══════════════════════════════════════════════════════════════════ */
    const TNX = (() => {
        try { const el = document.getElementById('tn-acc-data'); return el ? JSON.parse(el.textContent) : null; } catch (e) { return null; }
    })();
    const TNX_LEGACY = {};
    ACCESSORIES_DATA.forEach(a => { TNX_LEGACY[String(a.id)] = a; });
    // a régi listából kivett (de a TopApp által ajánlható) tételek rövid leírása
    TNX_LEGACY[MIC_ID] = TNX_LEGACY[MIC_ID] || { title: C.t.acc_mic_title, description: C.t.acc_mic_desc };
    TNX_LEGACY["51171571532116"] = TNX_LEGACY["51171571532116"] || { title: C.t.acc_rca_title, description: C.t.acc_rca_desc };
    const tnxState = { sid: '', bucket: 'default', queue: [], items: {}, shown: false };
    window.__tnxAcc = tnxState;
    /* 2026-09-19 (tulaj: „a Pioneerhez is ajánljunk kiegészítőket”): az Android-lapon a Pioneer/Kenwood kártyáról jövő kosárba tétel —
       a product-pioneer-alt.liquid adja át (TNX_POPUP.openAlt): a fő tétel a szett változata, a szelet 'pioneer', a fólia a szett kijelzőméretéhez. */
    let tnxAlt = null;
    const tnxSS = () => (tnxAlt && tnxAlt.screen) || (TNX && TNX.ss) || '';

    const tnxBucket = () => {
        if (tnxAlt) return tnxAlt.bucket || 'pioneer';
        if (TNX && TNX.bh) return 'pioneer'; // márkás (Pioneer, Kenwood, JBL…) fejegység: üvegfólia + autóápolás, menetrögzítő nélkül
        const sel = document.getElementById('selected-variant-id');
        const vt = ((sel && sel.getAttribute('data-variant-title')) || '').toUpperCase().replace(/\s+/g, '');
        const ver = ((sel && sel.getAttribute('data-selected-version')) || getSelectedProductVersion() || '').toUpperCase();
        if (/8GB\+?256GB/.test(vt) || /PR[ÉE]MIUM\+/.test(ver)) return 'premium_plus';
        if (/8GB\+?128GB/.test(vt) || /PR[ÉE]MIUM/.test(ver)) return 'premium';
        if (/6GB\+?128GB/.test(vt) || ver.indexOf('ELITE') !== -1) return 'elite';
        if (/4GB\+?64GB/.test(vt) || /(^|[^A-Z])PRO([^A-Z]|$)/.test(ver)) return 'pro';
        if (/2GB\+?32GB/.test(vt) || ver.indexOf('STANDARD') !== -1) return 'standard';
        if (/1GB\+?16GB/.test(vt) || ver.indexOf('ALAP') !== -1 || ver.indexOf('BASIC') !== -1) return 'alap';
        return 'default';
    };
    const TNX_TIER_LABEL = { alap: 'ALAP', standard: 'STANDARD', pro: 'PRO', elite: 'ELITE', premium: 'PRÉMIUM', premium_plus: 'PRÉMIUM+' };
    const tnxLowTier = (b) => b === 'alap' || b === 'standard';

    const tnxVariant = () => {
        if (tnxAlt) return tnxAlt.variantId || null;
        const sel = document.getElementById('selected-variant-id');
        return sel ? parseInt(sel.getAttribute('data-variant-id'), 10) || null : null;
    };
    const tnxFlush = () => {
        if (!TNX || !tnxState.queue.length || !tnxState.sid) return;
        const body = JSON.stringify({ sid: tnxState.sid, events: tnxState.queue.splice(0, 40) });
        try {
            if (navigator.sendBeacon) navigator.sendBeacon(TNX.api, new Blob([body], { type: 'text/plain' }));
            else fetch(TNX.api, { method: 'POST', body: body, keepalive: true, mode: 'cors', headers: { 'Content-Type': 'text/plain' } });
        } catch (e) { /* a mérés hibája nem akaszthatja meg a vásárlást */ }
        if (tnxState.queue.length) tnxFlush();
    };
    const tnxTrack = (event, it) => {
        if (!TNX || !tnxState.sid) return;
        const ev = { event: event, b: tnxState.bucket, pp: TNX.pid, pv: tnxVariant() };
        if (it) { ev.av = parseInt(it.id, 10); ev.ap = it.pid || null; ev.po = it.pos; }
        tnxState.queue.push(ev);
        if (tnxState.queue.length >= 30) tnxFlush();
    };
    const tnxNewSession = () => {
        tnxFlush();
        let s = '';
        try { const a = new Uint8Array(12); crypto.getRandomValues(a); a.forEach(x => { s += x.toString(16).padStart(2, '0'); }); }
        catch (e) { s = (Date.now().toString(16) + Math.random().toString(16).slice(2)).slice(0, 24); }
        tnxState.sid = s; tnxState.shown = false;
    };
    window.addEventListener('pagehide', tnxFlush);
    // Kihagyás: a globális skip-kezelő (assets/tn-product-popup.js) átirányít — előtte küldjük.
    document.addEventListener('click', (e) => {
        const t = e.target && e.target.closest ? e.target.closest('#skip-accessories, .skip-accessories-step-1') : null;
        if (!t || !tnxState.sid) return;
        tnxTrack('skip'); tnxFlush();
    }, true);
    tnxState.proceed = () => { tnxTrack('proceed'); tnxFlush(); };

    // forintnál magyar ezres tagolás négy számjegytől is („2 690 Ft”), mint a kosárban
    const tnxMoney = (cents) => activeCurrency === 'HUF'
        ? Math.round((cents || 0) / 100).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ' Ft'
        : formatCurrency((cents || 0) / 100, activeCurrency);
    // a csomagkedvezmény forintban (bolt-pénznem) jön a TopAppból → a kosár pénznemére váltva
    const TNX_RATE = (window.Shopify && Shopify.currency && parseFloat(Shopify.currency.rate)) || 1;

    /** A szelet listája: TopApp-rangsor (készleten lévők) → különben a régi, beégetett lista. */
    const tnxList = (bucket) => {
        let out = [];
        // hosszú terméknév: „Név – leírás” → rövid név + leírás; a változatnév (pl. 720P) a névhez kerül
        const tnxItem = (vid, it, disc, pop, cat, legacy) => {
            let title = it.t, desc = it.d || '';
            const dash = title.indexOf(' – ');
            if (dash > 8) { if (!desc) desc = title.slice(dash + 3); title = title.slice(0, dash); }
            // a változatnév csak kameránál számít (felbontás) — másutt a régi, rövid név marad
            const showVt = !!it.vt && cat === 'camera';
            if (cat === 'screen' && tnxSS()) title = title + ' · ' + tnxSS() + '″';
            if (legacy && legacy.title && !showVt) title = legacy.title;
            if (showVt) {
                const base = title.replace(/^Univerzális\s+/i, '');
                title = base.charAt(0).toUpperCase() + base.slice(1) + ' · ' + it.vt.replace(/\s*-\s*/g, ' ').trim();
            }
            if (!desc && legacy) desc = legacy.description || '';
            return {
                id: vid, pid: it.p, title: title, desc: desc, img: it.img, price: it.pr,
                sale: disc > 0 ? Math.max(0, it.pr - Math.round(disc * 100 * TNX_RATE)) : null, disc: disc,
                compare: it.cp > it.pr ? it.cp : 0, qty: it.q, reason: pop ? 'fogyas' : 'uj', cat: cat || 'other', tn: true
            };
        };
        if (TNX && TNX.i && TNX.b) {
            const rows = TNX.b[bucket] || TNX.b['default'] || [];
            rows.forEach((r) => { // [variant_id, csomagkedvezmény Ft, népszerű 0/1, kategória]
                const vid = String(r[0]);
                const it = TNX.i[vid];
                if (!it) return;
                out.push(tnxItem(vid, it, Number(r[1]) || 0, r[2], r[3], TNX_LEGACY[vid]));
            });
            // Kijelzővédő üvegfólia: csak a termék kijelzőméretéhez illő változat, a TopApp által adott helyre
            const scr = TNX.sc && (TNX.sc[bucket] || (!TNX.b[bucket] && TNX.sc['default']));
            const ss = tnxSS();
            if (scr && ss && scr[1] && scr[1][ss]) {
                const svid = String(scr[1][ss]);
                const sit = TNX.i[svid];
                if (sit && !out.some(x => x.id === svid)) {
                    const sItem = tnxItem(svid, sit, 0, 1, 'screen', null);
                    sItem.fitSize = ss;
                    out.splice(Math.min(Number(scr[0]) || 0, out.length), 0, sItem);
                }
            }
            // Márkaspecifikus kamera az erősebb változatoknál: az univerzális kamera helyére (két kamera soha)
            if (TNX.bc && Array.isArray(TNX.bcb) && TNX.bcb.indexOf(bucket) !== -1) {
                const bc = tnxItem(String(TNX.bc.id), TNX.bc, 0, 1, 'camera', null);
                bc.brand = true;
                const ci = out.findIndex(x => x.cat === 'camera');
                if (ci !== -1) out.splice(ci, 1, bc); else out.splice(Math.min(2, out.length), 0, bc);
            }
            // Menetrögzítőből és tolatókamerából mindig csak EGY ajánlás (2026-09-16, tulaj) — a lista elején álló (márkás / legjobb) marad
            const tnxOnce = {};
            out = out.filter((x) => {
                if (x.cat !== 'camera' && x.cat !== 'dashcam') return true;
                if (tnxOnce[x.cat]) return false;
                tnxOnce[x.cat] = true;
                return true;
            });
        }
        if (!out.length) {
            out = ACCESSORIES_DATA.map((a) => {
                const p = a.prices[activeCurrency] || a.prices['HUF'];
                return { id: String(a.id), pid: null, title: a.title, desc: a.description, img: a.image_url, price: p * 100, sale: null, disc: 0, compare: 0, qty: null, reason: '', tn: false };
            });
        }
        // Termékszintű tiltások (a meglévő szabályok szerint)
        if (DISPLAY_RCA_AMP === true) out = out.filter(x => x.id !== RCA_ID && x.id !== STD_ANTENNA_ID);
        if (_hideIds.length) out = out.filter(x => !_hideIds.includes(x.id));
        if (!tnxLowTier(bucket)) out = out.filter(x => x.id !== RCA_ID); // PRO-tól alapból tartozék
        // 2026-10-08 (tulaj): amit ehhez a fejegységhez AJÁNDÉKBA adunk (custom.freemic_variant: A = mikrofon +
        // antennaerősítő, C = mikrofon + Fakra antennaerősítő, B = mikrofon), azt NE ajánljuk megvételre —
        // a helyükre a rangsor következő termékei lépnek. Forrás: a termékoldali (rejtett) ajándék-gomb adatai.
        const tnxGiftEl = !tnxAlt && document.querySelector('[data-ap-gift]');
        if (tnxGiftEl) {
            const tnxGiftIds = [tnxGiftEl.getAttribute('data-mic-id'), tnxGiftEl.getAttribute('data-antenna-id')].filter(Boolean).map(String);
            if (tnxGiftIds.length) out = out.filter(x => tnxGiftIds.indexOf(String(x.id)) === -1);
        }
        // A mikrofon alacsony változatnál RCA kábelköteggel működik — ha RCA nem ajánlható, a mikrofon sem.
        if (tnxLowTier(bucket) && !out.some(x => x.id === RCA_ID)) out = out.filter(x => x.id !== MIC_ID);
        out.forEach((x, i) => { x.pos = i + 1; });
        return out;
    };

    const tnxUpdateSummary = (popup) => {
        const sum = popup.querySelector('[data-tnx-sum]');
        if (!sum) return;
        let n = 0, total = 0;
        selectedAccessoryIds.forEach((id) => {
            const it = tnxState.items[id];
            if (!it) return;
            n++; total += (it.sale != null ? it.sale : it.price);
        });
        if (!n) { sum.hidden = true; sum.textContent = ''; return; }
        sum.hidden = false;
        sum.innerHTML = '<span>' + n + ' kiegészítő a csomagban</span><strong>+' + tnxMoney(total) + '</strong>';
    };

    const tnxSetCard = (popup, id, on) => {
        const card = popup.querySelector('.tnx-acc-item[data-id="' + id + '"]');
        if (!card) return;
        card.classList.toggle('is-selected', on);
        const btn = card.querySelector('.tnx-acc-add');
        if (btn) {
            btn.setAttribute('aria-pressed', on ? 'true' : 'false');
            const t = btn.querySelector('.tnx-acc-add-txt');
            if (t) t.textContent = on ? 'Hozzáadva' : 'Hozzáadom';
        }
    };

    const tnxToggle = (popup, id) => {
        const it = tnxState.items[id];
        if (!it) return;
        const on = !selectedAccessoryIds.has(id);
        const note = (text) => {
            const n = popup.querySelector('.tnx-acc-item[data-id="' + MIC_ID + '"] .tnx-acc-note');
            if (n) { n.textContent = text || ''; n.hidden = !text; }
        };
        if (on) {
            selectedAccessoryIds.add(id); tnxSetCard(popup, id, true); tnxTrack('add', it);
            if (id === MIC_ID && tnxLowTier(tnxState.bucket) && tnxState.items[RCA_ID] && !selectedAccessoryIds.has(RCA_ID)) {
                selectedAccessoryIds.add(RCA_ID); tnxSetCard(popup, RCA_ID, true); tnxTrack('add', tnxState.items[RCA_ID]);
                note('Ennél a változatnál RCA csatlakozóval működik — azt is hozzáadtuk.');
            }
        } else {
            selectedAccessoryIds.delete(id); tnxSetCard(popup, id, false); tnxTrack('remove', it);
            if (id === RCA_ID && tnxLowTier(tnxState.bucket) && selectedAccessoryIds.has(MIC_ID)) {
                selectedAccessoryIds.delete(MIC_ID); tnxSetCard(popup, MIC_ID, false); tnxTrack('remove', tnxState.items[MIC_ID]);
            }
            if (id === MIC_ID) note('');
        }
        tnxUpdateSummary(popup);
    };

    const tnxEsc = (s) => String(s == null ? '' : s).replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));

    const renderAccessories = (popup) => {
        const wrap = popup.querySelector('[data-tnx-acc]');
        if (!wrap) return;
        const bucket = tnxBucket();
        tnxState.bucket = bucket;
        const sub = popup.querySelector('[data-tnx-sub]');
        if (sub) sub.textContent = TNX_TIER_LABEL[bucket] ? ('A ' + TNX_TIER_LABEL[bucket] + ' változathoz ezeket választják a legtöbben') : 'Ezeket választják hozzá a legtöbben';
        const bucketKey = bucket + '|' + tnxSS() + (tnxAlt ? '|alt' : '');
        if (wrap.dataset.bucket === bucketKey && wrap.children.length) { tnxUpdateSummary(popup); return; }

        const list = tnxList(bucket);
        tnxState.items = {};
        list.forEach(it => { tnxState.items[it.id] = it; });
        // a szeletből kiesett, korábban kijelölt tételek törlése
        Array.from(selectedAccessoryIds).forEach(id => { if (!tnxState.items[id]) selectedAccessoryIds.delete(id); });

        wrap.innerHTML = list.map((it) => {
            const on = selectedAccessoryIds.has(it.id);
            const priceNow = it.sale != null ? it.sale : it.price;
            const old = it.sale != null ? it.price : (it.compare || 0);
            const badge = it.disc > 0
                ? '<span class="tnx-acc-badge tnx-acc-badge--deal">-' + tnxMoney(Math.round(it.disc * 100 * TNX_RATE)) + ' a készülék mellé</span>'
                : (it.fitSize ? '<span class="tnx-acc-badge tnx-acc-badge--fit">Illik a ' + tnxEsc(it.fitSize) + '″ kijelzőhöz</span>'
                : it.brand ? '<span class="tnx-acc-badge tnx-acc-badge--fit">Pont ehhez az autóhoz</span>'
                : (it.pos <= 2 && it.reason && it.reason !== 'uj' ? '<span class="tnx-acc-badge">Népszerű</span>' : ''));
            const low = it.qty != null && it.qty > 0 && it.qty <= 5 ? '<span class="tnx-acc-stock">Már csak ' + it.qty + ' db</span>' : '';
            return '<div class="tnx-acc-item' + (on ? ' is-selected' : '') + '" data-id="' + tnxEsc(it.id) + '">'
                + '<div class="tnx-acc-img">' + (it.img ? '<img src="' + tnxEsc(it.img) + '" alt="" width="120" height="120" loading="lazy" decoding="async">' : '') + '</div>'
                + '<div class="tnx-acc-body">'
                +   '<div class="tnx-acc-name">' + tnxEsc(it.title) + '</div>' + badge
                +   (it.desc ? '<p class="tnx-acc-desc">' + tnxEsc(it.desc) + '</p>' : '')
                +   '<div class="tnx-acc-price"><strong>' + tnxMoney(priceNow) + '</strong>' + (old > priceNow ? '<del>' + tnxMoney(old) + '</del>' : '') + low + '</div>'
                +   '<p class="tnx-acc-note" hidden></p>'
                + '</div>'
                + '<button type="button" class="tnx-acc-add" data-id="' + tnxEsc(it.id) + '" aria-pressed="' + (on ? 'true' : 'false') + '" aria-label="' + tnxEsc('Hozzáadom: ' + it.title + ', ' + tnxMoney(priceNow)) + '">'
                +   '<svg class="tnx-i-plus" viewBox="0 0 24 24" aria-hidden="true"><path d="M12 5v14M5 12h14"/></svg>'
                +   '<svg class="tnx-i-check" viewBox="0 0 24 24" aria-hidden="true"><path d="M20 6 9 17l-5-5"/></svg>'
                +   '<span class="tnx-acc-add-txt">' + (on ? 'Hozzáadva' : 'Hozzáadom') + '</span>'
                + '</button>'
                + '</div>';
        }).join('');
        wrap.dataset.bucket = bucketKey;
        wrap.onclick = (e) => {
            const card = e.target.closest ? e.target.closest('.tnx-acc-item') : null;
            if (!card) return;
            e.preventDefault(); e.stopPropagation();
            tnxToggle(popup, card.getAttribute('data-id'));
        };
        tnxUpdateSummary(popup);
    };

    /** Megjelenés-mérés: amikor a lista ténylegesen látható (garancia- / ajándék-lépés után is). */
    const tnxOnOpen = (popup) => {
        const wrap = popup.querySelector('[data-tnx-acc]');
        if (!wrap) return;
        const check = () => {
            if (tnxState.shown || popup.classList.contains('hidden') || !wrap.offsetParent) return;
            tnxState.shown = true;
            Object.keys(tnxState.items).forEach(id => tnxTrack('impression', tnxState.items[id]));
            tnxFlush();
        };
        check();
        if (!popup._tnxObs) {
            // setTimeout (nem rAF): háttérlapon a rAF szünetel, a mérés akkor se maradjon ki
            popup._tnxObs = new MutationObserver(() => setTimeout(check, 30));
            popup._tnxObs.observe(popup, { attributes: true, subtree: true, attributeFilter: ['class', 'hidden', 'style'] });
        }
        popup._tnxCheck = check;
    };

    // --- WARRANTY RENDER LOGIC ---
    const renderWarranty = (popup, version) => {
        const container = popup.querySelector('.warranty-selection-container');
        if (!container) return;

        container.innerHTML = '';

        // === TIER-GROUP SZŰRÉS ===
        // A garancia-szekciót CSAK az ELITE / PRÉMIUM / PRÉMIUM+ tier-eknél mutatjuk.
        // ALAP / STANDARD / PRO → kihagyjuk a warranty step-et, csak az accessory-t mutatjuk.
        let lowTierDetect = '';
        if (version) {
            const vUp = version.toUpperCase().replace(/\s+/g, '');
            if (vUp.includes("1GB") && vUp.includes("16GB")) lowTierDetect = 'ALAP';
            else if (vUp.includes("2GB") && vUp.includes("32GB")) lowTierDetect = 'STANDARD';
            else if (vUp.includes("4GB") && vUp.includes("64GB")) lowTierDetect = 'PRO';
            else if (version.toUpperCase().includes("ALAP") || version.toUpperCase().includes("BASIC")) lowTierDetect = 'ALAP';
            else if (version.toUpperCase().includes("STANDARD")) lowTierDetect = 'STANDARD';
            else if (version.toUpperCase().includes("PRO") && !version.toUpperCase().includes("PRÉMIUM") && !version.toUpperCase().includes("PREMIUM")) lowTierDetect = 'PRO';
        }
        // 2026-09-15: TopApp-beállítás — PRO is bekapcsolható, ELITE-től egyenként kikapcsolható
        const tnWT = window.TN_WARRANTY_TIERS;
        if (tnWT) {
            const vU = (version || '').toUpperCase().replace(/\s+/g, '');
            const tk = vU.includes('8GB+256GB') || /PR[ÉE]MIUM\+/.test(vU) ? 'premium_plus'
                     : vU.includes('8GB+128GB') || /PR[ÉE]MIUM/.test(vU) ? 'premium'
                     : vU.includes('6GB+128GB') || vU.includes('ELITE') ? 'elite'
                     : vU.includes('4GB+64GB') || /(^|[^A-Z])PRO([^A-Z]|$)/.test(vU) ? 'pro' : '';
            if (tk === 'pro' && tnWT.indexOf('pro') !== -1) lowTierDetect = '';
            else if (tk && tk !== 'pro' && tnWT.indexOf(tk) === -1) lowTierDetect = 'OFF';
        }
        if (tnxAlt || (TNX && TNX.bh) || (version && version.toUpperCase() === 'PIONEER')) lowTierDetect = 'OFF'; /* 2026-09-19: Pioneer/Kenwood szett → nincs garancia-lépés */
        if (lowTierDetect) {
            // Wizard-popup: ugorjunk EGYBŐL a step 2-re (accessory), és rejtsük el a "vissza a garanciához" gombot
            const step1 = popup.querySelector('#popup-step-1');
            const step2 = popup.querySelector('#popup-step-2');
            const btnBack = popup.querySelector('#btn-back-to-warranty');
            if (step1 && step2) {
                step1.classList.add('hidden');
                step2.classList.remove('hidden');
            }
            if (btnBack) btnBack.style.display = 'none';
            return; // ne rendereljük a garancia-választót
        }
        // 2026-09-15: ha korábban alacsonyabb változattal nyílt a popup, a vissza gomb rejtve maradt volna
        const btnBackRestore = popup.querySelector('#btn-back-to-warranty');
        if (btnBackRestore) btnBackRestore.style.display = '';

        
        // Determine type based on version string — GB-kombinációt és kulcsszót is figyel
        let type = null;
        if (version) {
            const v = version.toUpperCase();
            const vNoSpace = v.replace(/\s+/g, "");

            // 1) GB-kombináció (a determineWarrantyType-tal egyezően)
            if (vNoSpace.includes("8GB") && vNoSpace.includes("256GB")) type = "PRÉMIUM+";
            else if (vNoSpace.includes("6GB") && vNoSpace.includes("128GB")) type = "ELITE";
            else if (vNoSpace.includes("8GB") && vNoSpace.includes("128GB")) type = "PRÉMIUM";
            else if (vNoSpace.includes("4GB") && vNoSpace.includes("64GB")) type = "PRO";
            else if (vNoSpace.includes("2GB") && vNoSpace.includes("32GB")) type = "STANDARD";
            else if (vNoSpace.includes("1GB") && vNoSpace.includes("16GB")) type = "ALAP";
            // 2) Kulcsszó fallback (csak ha még nem találtunk)
            else if (v.includes("PRÉMIUM+") || v.includes("PREMIUM+")) type = "PRÉMIUM+";
            else if (v.includes("ELITE")) type = "ELITE";
            else if (v.includes("PRÉMIUM") || v.includes("PREMIUM")) type = v.includes("PRÉMIUM") ? "PRÉMIUM" : "PREMIUM";
            else if (v.includes("PRO")) type = "PRO";
            else if (v.includes("STANDARD")) type = "STANDARD";
            else if (v.includes("ALAP") || v.includes("BASIC")) type = "ALAP";

            // 3) PRÉMIUM <-> PREMIUM csere ha nincs config
            if (type && WARRANTY_CONFIG && !WARRANTY_CONFIG[type]) {
                if (type === "PRÉMIUM" && WARRANTY_CONFIG["PREMIUM"]) type = "PREMIUM";
                else if (type === "PREMIUM" && WARRANTY_CONFIG["PRÉMIUM"]) type = "PRÉMIUM";
            }
        }

        console.log("Warranty Render: Version:", version, "Type:", type);

        if (type && WARRANTY_CONFIG[type]) {
            const config = WARRANTY_CONFIG[type];
            
            // Helper to get formatted price (converted/fixed)
            const getPriceHtml = (yearKey, priceCents) => {
                if (activeCurrency === 'HUF') return tnxMoney(priceCents); // 2026-09-15: egységes „10 990 Ft”
                // Use the globally available fixed-price calculator if possible
                if (window.getWarrantyPrice) {
                    return window.getWarrantyPrice(type, yearKey, priceCents);
                }
                // Fallback
                if (window.formatMoneyConverted) {
                    return window.formatMoneyConverted(priceCents);
                }
                return formatCurrency(priceCents);
            };

            /* 2026-09-23: az alap jótállás a KIVÁLASZTOTT változat árától függ (250 000 Ft felett 3 év) */
            const tnwVidEl = document.querySelector('form[action*="/cart/add"] [name="id"]');
            const tnwBase = (tnwVidEl && window.TN_W3Y && window.TN_W3Y[String(tnwVidEl.value)]) ? 3 : 2;
            const html = `
                <div class="tnw-pop-hero">
                    <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 3l7 3v5.5c0 4.3-2.9 8.1-7 9.5-4.1-1.4-7-5.2-7-9.5V6l7-3z"/><path d="M8.6 12.2l2.3 2.3 4.6-4.8"/></svg>
                    <p>Alap jótállás: <b>${tnwBase} év</b>. A hosszabbítás ehhez adódik hozzá.</p>
                </div>
                <div class="tnw-pop-list" role="radiogroup" aria-label="Garancia-hosszabbítás">
                    <label class="tnw-pop-opt is-selected">
                        <input type="radio" name="warranty_popup_add" class="warranty-radio-hidden" value="" checked>
                        <span class="tnw-pop-ico"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 3l7 3v5.5c0 4.3-2.9 8.1-7 9.5-4.1-1.4-7-5.2-7-9.5V6l7-3z"/></svg></span>
                        <span class="tnw-pop-main">
                            <span class="tnw-pop-name">Csak az alap jótállás</span>
                            <span class="tnw-pop-meta">Összesen ${tnwBase} év</span>
                        </span>
                        <span class="tnw-pop-price tnw-pop-price--free">Benne van</span>
                        <span class="tnw-pop-radio" aria-hidden="true"><svg viewBox="0 0 24 24"><path d="M20 6 9 17l-5-5"/></svg></span>
                    </label>
                    <label class="tnw-pop-opt">
                        <input type="radio" name="warranty_popup_add" class="warranty-radio-hidden" value="${config['1y'].id}">
                        <span class="tnw-pop-ico tnw-pop-ico--plus"><b>+1</b><small>év</small></span>
                        <span class="tnw-pop-main">
                            <span class="tnw-pop-name">+1 év garancia</span>
                            <span class="tnw-pop-meta">Összesen ${tnwBase + 1} év</span>
                        </span>
                        <span class="tnw-pop-price">+${getPriceHtml('1y', config['1y'].price)}</span>
                        <span class="tnw-pop-radio" aria-hidden="true"><svg viewBox="0 0 24 24"><path d="M20 6 9 17l-5-5"/></svg></span>
                    </label>
                    <label class="tnw-pop-opt tnw-pop-opt--best">
                        <span class="tnw-pop-flag">Legtöbben ezt választják</span>
                        <input type="radio" name="warranty_popup_add" class="warranty-radio-hidden" value="${config['2y'].id}">
                        <span class="tnw-pop-ico tnw-pop-ico--plus"><b>+2</b><small>év</small></span>
                        <span class="tnw-pop-main">
                            <span class="tnw-pop-name">+2 év garancia</span>
                            <span class="tnw-pop-meta">Összesen ${tnwBase + 2} év</span>
                        </span>
                        <span class="tnw-pop-price">+${getPriceHtml('2y', config['2y'].price)}</span>
                        <span class="tnw-pop-radio" aria-hidden="true"><svg viewBox="0 0 24 24"><path d="M20 6 9 17l-5-5"/></svg></span>
                    </label>
                </div>
                <ul class="tnw-pop-benefits">
                    <li>${C.t.warranty_feature_1}</li>
                    <li>${C.t.warranty_feature_2}</li>
                    <li>${C.t.warranty_feature_3}</li>
                </ul>
            `;
            container.innerHTML = html;
            /* 2026-09-30 (2.4.1): a garancia feltételei a választó alatt (ÁSZF 16.3.) — snippets/tn-warranty-terms */
            const tnwTpl = document.getElementById('tn-wterms-tpl');
            if (tnwTpl && tnwTpl.content) container.appendChild(tnwTpl.content.cloneNode(true));
            // a kiválasztás jelzése (rádiógomb → kártya-állapot és gombfelirat)
            const tnwSync = () => {
                container.querySelectorAll('.tnw-pop-opt').forEach((opt) => {
                    const on = !!opt.querySelector('input').checked;
                    opt.classList.toggle('is-selected', on);
                    const t = opt.querySelector('.tnx-acc-add-txt');
                    if (t) t.textContent = on ? t.getAttribute('data-on') : t.getAttribute('data-off');
                });
            };
            container.querySelectorAll('input[name="warranty_popup_add"]').forEach((inp) => inp.addEventListener('change', tnwSync));
            tnwSync();
            container.classList.remove('hidden');
        } else {
            container.classList.add('hidden');
        }
    };

    const handleCartProcess = async (event, skip) => {
        event.preventDefault();
        const popup = event.target.closest('.popup-overlay');
        const ctaButton = popup.querySelector('#proceed-to-cart');
        const btnText = ctaButton ? ctaButton.querySelector('.btn-text') : null;
        const loader = ctaButton ? ctaButton.querySelector('.loader') : null;

        if (ctaButton) ctaButton.disabled = true;
        if (btnText) btnText.style.display = 'none';
        if (loader) loader.classList.remove('hidden');

        // Note: If skipping accessories, we clear the selection. 
        // BUT we must NOT clear the warranty selection (which is a radio input, not in the set).
        if (skip) selectedAccessoryIds.clear();
        else if (window.__tnxAcc && window.__tnxAcc.proceed) window.__tnxAcc.proceed();

        try {
            const form = document.querySelector('form[action$="/cart/add"]');
            const formData = new FormData(form);
            // Use our synced variant ID if available, otherwise form
            const idEl = document.getElementById('selected-variant-id');
            const currentVariantId = idEl ? idEl.getAttribute('data-variant-id') : null;
            const altMain = tnxAlt; // Pioneer/Kenwood szett a kártyáról (2026-09-19)
            const mainId = altMain ? altMain.variantId : (parseInt(currentVariantId) || parseInt(formData.get('id')));
            const qty = altMain ? (altMain.qty || 1) : (parseInt(formData.get('quantity')) || 1);
            
            // Vendor Check
            const vendor = C.vendor;
            const isSplitVendor = (vendor === "Márkaspecifikus multimédia");

            if (!mainId || isNaN(mainId)) {
                throw new Error(C.t.alert_invalid_id);
            }

            // 1. Prepare Payload
            const uniqueID = Date.now() + Math.random().toString(36).substr(2, 9); // Strict Linking ID

            let mainItems = [];

            if (altMain) {
                mainItems.push({ id: mainId, quantity: qty, properties: Object.assign({ '_unique_id': uniqueID }, altMain.props || {}) });
            } else if (isSplitVendor && qty > 1) {
                for (let i = 0; i < qty; i++) {
                    const itemID = Date.now() + Math.random().toString(36).substr(2, 9);
                    mainItems.push({ 
                        id: mainId, 
                        quantity: 1, 
                        properties: { '_split_id': Date.now() + "_" + i, '_unique_id': itemID } 
                    });
                }
            } else if (isSplitVendor && qty === 1) {
                mainItems.push({ 
                    id: mainId, 
                    quantity: 1, 
                    properties: { '_split_id': Date.now(), '_unique_id': uniqueID } 
                });
            } else {
                mainItems.push({ 
                    id: mainId, 
                    quantity: qty,
                    properties: { '_unique_id': uniqueID } // Attach Unique ID
                });
            }

            // 2026-10-09 (OKT10): a pénztárban is látszódjon az ajándék — a termékűrlap rejtett „OKT10 ajándék” mezője a fejegység sorába
            try {
                const gnEl = !altMain && form && form.querySelector('[data-okt10-giftnote]');
                if (gnEl && gnEl.value) {
                    mainItems.forEach(mi => { if (mi.id === mainId) mi.properties = Object.assign({}, mi.properties || {}, { 'HETVEGE10 ajándék': gnEl.value }); });
                }
            } catch (gnErr) { console.warn('[okt10-giftnote]', gnErr); }

            // Accessories
            // 2026-09-15: a popupból (TopApp-ajánlásból) jövő kiegészítő rejtett _tn_acc tulajdonságot kap → a rendelésből mérhető
            selectedAccessoryIds.forEach(id => {
                const tnxIt = tnxState.items[id];
                mainItems.push(tnxIt && tnxIt.tn ? { id, quantity: qty, properties: { _tn_acc: tnxState.bucket } } : { id, quantity: qty });
            });

            // 2026-10-08 (OKT10): az ajándék (custom.freemic_variant: A = mikrofon + antennaerősítő, C = mikrofon + Fakra
            // antennaerősítő, B = mikrofon) a fejegységgel EGY hívásban kerül a kosárba — CSAK aktivált kuponnal. (A termékoldali
            // ATC-figyelő ide nem ér el, mert ez a popup a kattintást capture-fázisban leállítja.)
            let tnxGiftCode = '';
            try {
                const gEl = !altMain && document.querySelector('[data-ap-gift]');
                if (gEl && window.tnOkt10 && window.tnOkt10.isOn()) {
                    const gh = gEl.getAttribute('data-product-handle') || '';
                    const gCart = await (await fetch('/cart.js', { credentials: 'same-origin' })).json();
                    const gHas = (gCart.items || []).some(it => it.properties && it.properties._gift_parent === gh);
                    if (gh && !gHas) {
                        const gProps = { 'Ajándék': 'Igen', '_gift_parent': gh };
                        [gEl.getAttribute('data-mic-id'), gEl.getAttribute('data-antenna-id')].filter(Boolean).forEach(gid => {
                            mainItems.push({ id: parseInt(gid, 10), quantity: 1, properties: gProps });
                        });
                        tnxGiftCode = gEl.getAttribute('data-coupon-code') || '';
                    }
                }
            } catch (gErr) { console.warn('[okt10-gift]', gErr); }

            // Bundle add-ons (snippets/product-addons.liquid, 2026-08-27):
            // a buy boxban bepipált "Kérd hozzá csomagban" tételek ugyanebbe a
            // /cart/add.js hívásba kerülnek (_bundle_parent + "Csomag" property).
            if (window.TN_ADDONS && typeof window.TN_ADDONS.getItems === 'function') {
                mainItems.push(...window.TN_ADDONS.getItems());
            }

            // 2. Send First Batch
            const res = await fetch('/cart/add.js', {
                method: 'POST',
                headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
                body: JSON.stringify({ items: mainItems })
            });

            // Biztonságos JSON-parse: Shopify néha HTML hibaoldalt küld vissza
            // (pl. 404 érvénytelen variant_id-nál, 500-as belső hibánál).
            // Az `await res.json()` ilyenkor "Unexpected token '<'" hibával robban.
            // Ezért előbb text-ként olvassuk be, és try-catch-ben próbáljuk JSON-ná
            // alakítani — így a felhasználó tisztességes hibaüzenetet kap.
            const rawText = await res.text();
            let data;
            try {
                data = JSON.parse(rawText);
            } catch (parseErr) {
                console.error("[Cart] Non-JSON response from /cart/add.js:", rawText.slice(0, 300));
                throw new Error(
                    !res.ok
                        ? `${C.t.alert_api_error} (${res.status})`
                        : C.t.alert_api_error
                );
            }

            if (!res.ok) {
                throw new Error(data.description || data.message || C.t.alert_api_error);
            }
            
            // Helper to normalize response items
            const getResponseItems = (d) => {
                 if(d.items) return d.items;
                 if(Array.isArray(d)) return d;
                 return [d];
            };
            const responseItems = getResponseItems(data);

            // 3. Warranty Logic
            const warrantyInput = popup.querySelector('input[name="warranty_popup_add"]:checked');
            
            // Only proceed if a warranty is actually selected (value is not empty)
            if (warrantyInput && warrantyInput.value) {
                let warrantyItems = [];
                const warrantyId = parseInt(warrantyInput.value);
                
                if (isSplitVendor) {
                    // Start looking for the split items we just added
                    const addedMains = responseItems.filter(i => i.id === mainId && i.properties && i.properties['_split_id']);
                    
                    addedMains.forEach(mItem => {
                        warrantyItems.push({
                            id: warrantyId,
                            quantity: 1,
                            properties: { '_parent_key': mItem.key, '_parent_unique_id': uniqueID, '_warranty': 'true' }
                        });
                    });
                } else {
                    // Standard: Try to find legal main item
                    let addedMain = responseItems.find(i => i.id === mainId);
                    
                    // FALLBACK: If merged, fetch full cart
                    if (!addedMain) {
                         console.warn("Main item merged. Fetching full cart...");
                         try {
                            const cartRes = await fetch('/cart.js');
                            const cartData = await cartRes.json();
                            // Find the item. Since it was just added/updated, it exists.
                            // We look for the one with matching ID and NO special split properties (standard).
                            addedMain = cartData.items.find(i => i.id === mainId);
                         } catch (err) {
                             console.error("Cart fetch error", err);
                         }
                    }

                    if (addedMain) {
                        // Construct Custom Property Value: "Product Title Variant Title"
                        let parentTitle = C.title;
                        // Try to get variant title from selected element or current state
                        const idEl = document.getElementById('selected-variant-id');
                        const vTitle = idEl ? idEl.getAttribute('data-variant-title') : null;
                        
                        if (vTitle && vTitle !== parentTitle && !vTitle.includes('Default Title')) {
                            parentTitle += ` ${vTitle}`;
                        }

                        warrantyItems.push({
                            id: warrantyId,
                            quantity: qty,
                            properties: { 
                                '_parent_key': addedMain.key, 
                                '_parent_unique_id': uniqueID, // STRICT LINKING
                                [C.t.property_connected_product]: parentTitle, // VISIBLE PROPERTY (Fixes missing text)
                                '_warranty': 'true' 
                            }
                        });
                    } else {
                        // If still not found, we can't attach warranty safely.
                        console.error("Main item key not found. WARRANTY ATTACHMENT FAILED.");
                        // alert("Hiba: A garanciát nem sikerült a termékhez kapcsolni. Kérlek ellenőrizd a kosarat!");
                    }
                }
                
                if (warrantyItems.length > 0) {
                     await fetch('/cart/add.js', {
                         method: 'POST',
                         headers: {'Content-Type': 'application/json'},
                         body: JSON.stringify({ items: warrantyItems })
                     });
                }
            }
            
            // OKT10: az ajándék ingyenességét adó FREEMIC-kód a meglévő kódok (OKT10) MELLÉ
            if (tnxGiftCode && window.tnCartCodes) { try { await window.tnCartCodes.add(tnxGiftCode); } catch (e) {} }

            const path = isBuyNowFlow ? 'checkout' : 'cart';
            let url = (selectedAccessoryIds.size > 0 && KEDVEZMENY_KOD) ? `/discount/${KEDVEZMENY_KOD}?redirect=/${path}` : `/${path}`;
            
            window.location.href = url;

        } catch(err) {
            console.error("Cart Process Error:", err);
            if(btnText) btnText.style.display = 'inline-block';
            if(loader) loader.classList.add('hidden');
            if (ctaButton) ctaButton.disabled = false;
            alert(C.t.alert_error_cart + " " + err.message);
        }
    };
    
    const showAccessoryPopup = (version) => {
        tnxNewSession();
        const targetId = (!version || version === 'STANDARD' || version === 'ALAP' || version === 'BASIC') ? 'accessory-popup-overlay-alap' : 'accessory-popup-overlay-other';
        const popup = document.getElementById(targetId);
        if (!popup) return;

        // Reset to Step 1 initially if it's the Wizard popup
        if (targetId === 'accessory-popup-overlay-other') {
            popup.querySelector('#popup-step-1').classList.remove('hidden');
            popup.querySelector('#popup-step-2').classList.add('hidden');
            
            // Render content
            renderWarranty(popup, version);
            renderAccessories(popup);
            
            // --- Navigation Logic ---
            const btnNext = popup.querySelector('#btn-step-1-next');
            const btnBack = popup.querySelector('#btn-back-to-warranty');
            
            if (btnNext) {
                btnNext.onclick = () => {
                   popup.querySelector('#popup-step-1').classList.add('hidden');
                   popup.querySelector('#popup-step-2').classList.remove('hidden');
                };
            }
            if (btnBack) {
                btnBack.onclick = () => {
                    popup.querySelector('#popup-step-2').classList.add('hidden');
                   popup.querySelector('#popup-step-1').classList.remove('hidden');
                };
            }
        } else {
             // ALAP/STANDARD/BASIC popup logic
             renderAccessories(popup);
             renderWarranty(popup, version);
        }

        popup.classList.remove('hidden');
        tnxOnOpen(popup);

        // A popup most láthatóvá vált — Swiper újraszámol (slide-szélesség,
        // translate, pagination). Mobilon ettől nincs többé elcsúszott kártya.
        requestAnimationFrame(() => {
            const swiper = swipers[popup.id];
            if (swiper && typeof swiper.update === 'function') {
                swiper.update();
                if (typeof swiper.slideTo === 'function') swiper.slideTo(0, 0);
            }
        });

        popup.querySelector('.close-btn').onclick = () => { popup.classList.add('hidden'); tnxAlt = null; };

        // Ensure actions are bound
        const proceedBtn = popup.querySelector('#proceed-to-cart');
        const skipBtn = popup.querySelector('#skip-accessories');

        // Fix: Also bind the Step 1 skip button
        const skipBtnStep1 = popup.querySelector('.skip-accessories-step-1');

        if (proceedBtn) proceedBtn.onclick = (e) => handleCartProcess(e, false);
    };

    const showUpgradePopup = () => {
        const popup = document.getElementById('upgrade-popup');
        if (!popup) { showAccessoryPopup('ALAP'); return; } /* 2026-09-23: az ablak csak ALAP-változatos terméken van a HTML-ben */
        popup.style.display = 'flex';
        popup.classList.remove('hidden');
        
        // "Alap verziónál maradok" -> Csak bezárja a popupot és folytatja a folyamatot (ALAP verzió marad)
        popup.querySelector('#upgrade-no').onclick = () => { 
            popup.style.display = 'none'; 
            popup.classList.add('hidden'); 
            // Itt folytathatnánk a kosárba rakást, ha szükséges, 
            // de a kérés szerint: "az alap verziónál maradok is jól látszódjon"
            // Ha a felhasználó marad, akkor az eredeti flow (kosárba rakás) folytatódik? 
            // A korábbi kódban: showAccessoryPopup('ALAP'); volt itt.
            showAccessoryPopup('ALAP'); 
        };

        // "Frissítek" -> Egyel nagyobb verzióra váltás
        popup.querySelector('#upgrade-yes').onclick = () => {
            popup.style.display = 'none';
            popup.classList.add('hidden');
            
            // Logic to select the next variant
            const current = document.querySelector('.swatch-element input[type="radio"]:checked');
            if (current) {
                 const allRadios = Array.from(document.querySelectorAll('.swatch-element input[type="radio"]'));
                 const currentIndex = allRadios.indexOf(current);
                 
                 if (currentIndex > -1 && currentIndex < allRadios.length - 1) {
                     // Kattintsunk a következőre
                     const nextRadio = allRadios[currentIndex + 1];
                     nextRadio.click();
                 }
            }
        };
    };

    // Eredeti version-alapú branching kiszervezve, hogy a Q7 MMI2G pre-popup
    // után újra meg tudjuk hívni (Kérem/Nem kérem kattintás után).
    const _continueAtcFlow = () => {
        if (TNX && TNX.bh) { showAccessoryPopup('PIONEER'); return; } /* Pioneer/Kenwood saját oldala: ugyanaz az ablak, 'pioneer' szelet */
        const version = getSelectedProductVersion();
        if (version === 'ALAP' || version === 'BASIC') {
            showUpgradePopup();
        } else if (version) {
            showAccessoryPopup(version);
        } else {
            showAccessoryPopup('');
        }
    };

    const interceptClick = (event, isBuyNow) => {
        // 1. Megkeressük a termék fő konténerét
        const productContainer = event.target.closest('.product_template');

        // 2. Kiolvassuk a metafield értékét. Csak akkor lesz igaz, ha az értéke PONTOSAN 'true'.
        const isPopupEnabled = productContainer ? productContainer.dataset.productPopup === 'true' : false;

        // 3. Ha a metafield értéke nem 'true', akkor ne csináljunk semmit.
        if (!isPopupEnabled) {
            return;
        }

        // Az eredeti logika csak akkor fut le, ha a fenti feltétel IGAZ volt.
        event.preventDefault(); event.stopImmediatePropagation();
        isBuyNowFlow = isBuyNow;

        // Q7 MMI2G pre-popup: ha a kiválasztott variant MMI2G, előbb az optikai
        // dekóder modal jelenik meg. A modal gombjai (Kérem/Nem kérem) hívják
        // meg utána a _continueAtcFlow()-t. Nem MMI2G → egyből a normál flow.
        const decoderPopup = document.getElementById('q7-mmi2g-decoder-popup');
        if (decoderPopup) {
            const variantEl = document.getElementById('selected-variant-id');
            const variantId = variantEl
                ? parseInt(variantEl.getAttribute('data-variant-id'), 10) || 0
                : 0;
            const mmi2gIds = (decoderPopup.getAttribute('data-mmi2g-ids') || '')
                .split(',').map(s => parseInt(s.trim(), 10)).filter(Boolean);
            if (variantId && mmi2gIds.indexOf(variantId) !== -1) {
                decoderPopup.classList.remove('hidden');
                const yBtn = decoderPopup.querySelector('#q7-decoder-yes');
                if (yBtn) yBtn.disabled = false;
                return;
            }
        }
        _continueAtcFlow();
    };

    /* Nyilvános API a product-pioneer-alt.liquid-nek (2026-09-19): enabled() = a lapon él a popup és van TopApp-ajánlás;
       openAlt(item) = a szett-tétellel nyitja a kiegészítő-lépést ('pioneer' szelet, garancia-lépés nélkül). */
    window.TNX_POPUP = {
        enabled: () => {
            const pc = document.querySelector('.product_template');
            return !!(pc && pc.dataset.productPopup === 'true' && TNX && TNX.b);
        },
        openAlt: (item) => {
            if (!item || !item.variantId) return;
            tnxAlt = Object.assign({ bucket: 'pioneer' }, item);
            isBuyNowFlow = false;
            showAccessoryPopup('PIONEER'); /* ugyanaz a varázsló-ablak, mint az Android-szinteknél; a garancia-lépést a renderWarranty ugorja */
        }
    };

    // Q7 MMI2G decoder popup gombok kötése — egyszer, DOM-load után.
    (function bindQ7DecoderPopup() {
        const popup = document.getElementById('q7-mmi2g-decoder-popup');
        if (!popup) return;
        const yesBtn = popup.querySelector('#q7-decoder-yes');
        const noBtn = popup.querySelector('#q7-decoder-no');
        const decoderId = parseInt(popup.getAttribute('data-decoder-id') || '0', 10);

        function finish() {
            popup.classList.add('hidden');
            _continueAtcFlow();
        }

        if (yesBtn && decoderId) {
            yesBtn.addEventListener('click', (e) => {
                e.preventDefault();
                yesBtn.disabled = true;
                fetch('/cart/add.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ items: [{ id: decoderId, quantity: 1 }] }),
                    credentials: 'same-origin'
                }).then(() => finish())
                  .catch(err => {
                      console.warn('[Q7 MMI2G] dekóder add hiba:', err);
                      finish(); // hiba esetén is folytatás
                  });
            });
        }
        if (noBtn) {
            noBtn.addEventListener('click', (e) => {
                e.preventDefault();   // <a href="#"> — ne ugráljon a tetejére
                finish();
            });
        }
    })();

    // 4. CAPTURE-PHASE EVENT DELEGATION (FIX DOUBLE ADD)
    // We listen on the document with {capture: true} to intercept the click 
    // BEFORE it reaches the button or any other handlers (like generic form submitters).
    document.addEventListener('click', (e) => {
        // Find the button (it might be the target or a parent)
        const btn = e.target.closest('.add-to-cart-with-accessories');
        
        if (btn) {
            // We found the button! Now intercept.
            interceptClick(e, false);
        }
        
        // Handle "Buy Now" similarly if needed, but usually it's separate
        const buyNow = e.target.closest('.buy-now-custom');
        if (buyNow) {
             interceptClick(e, true);
        }
        
    }, true); // <--- TRUE is key: Capture Phase

    /* 
    // OLD FLAKY METHOD (Removed)
    const cartBtn = document.querySelector(".add-to-cart-with-accessories");
    const buyNowBtn = document.querySelector(".buy-now-custom");
    if (cartBtn) cartBtn.addEventListener('click', (e) => interceptClick(e, false), true);
    if (buyNowBtn) buyNowBtn.addEventListener('click', (e) => interceptClick(e, true), true); 
    */
};

/* ===== blokk 1 ===== */


document.addEventListener("DOMContentLoaded", function () {
  // Globális tömb a kiválasztott kiegészítők azonosítóinak tárolására
  const selectedAccessoryIds = [];
  const rcaId = 51171571532116;  // RCA csatlakozó ID
  const micId = 51064671338836;  // Külső mikrofon ID

  // Lekérjük a mikrofon gombot
  const micButton = document.querySelector(`.add-accessory-btn[data-id='${micId}']`);
  if (micButton) {
    // Alapértelmezetten nem jelenik meg a gomb, hanem egy üzenet jelenik meg
    micButton.style.display = "none";
    let micReplacementDiv = document.createElement("div");
    micReplacementDiv.id = "mic-replacement";
    micReplacementDiv.textContent = TNPP.t.rca_required;
    micReplacementDiv.classList.add("accessory-message"); // Ezt stílusosan meg is formázhatod CSS-ben
    // Helyezzük el a gomb után
    micButton.parentNode.insertBefore(micReplacementDiv, micButton.nextSibling);
  }

  // Az összes kiegészítő gombjára felveszünk egy event listener–t:
  document.querySelectorAll(".add-accessory-btn").forEach(button => {
    button.addEventListener("click", function () {
      const accessoryId = parseInt(this.getAttribute("data-id"));

      // Ha a gomb már "hozzáadva" állapotban van, akkor visszavonjuk a hozzáadást:
      if (selectedAccessoryIds.includes(accessoryId)) {
        // Töröljük az adott kiegészítőt a tömbből
        selectedAccessoryIds.splice(selectedAccessoryIds.indexOf(accessoryId), 1);
        // Visszaállítjuk a gomb eredeti állapotát
        this.innerText = TNPP.t.add_btn;
        this.disabled = false;
        this.classList.remove("added");

        // Ha az eltávolított kiegészítő az RCA, akkor a mikrofon gombot is visszavonjuk:
        if (accessoryId === rcaId) {
          // Töröljük az RCA-t, majd:  
          // - A mikrofon gombot elrejtjük
          const micBtn = document.querySelector(`.add-accessory-btn[data-id='${micId}']`);
          if (micBtn) {
            micBtn.style.display = "none";
          }
          // - Hozzáadjuk a helyettesítő divet, ha még nincs
          if (!document.getElementById("mic-replacement") && micBtn) {
            let newReplacement = document.createElement("div");
            newReplacement.id = "mic-replacement";
            newReplacement.textContent = TNPP.t.rca_required;
            newReplacement.classList.add("accessory-message");
            micBtn.parentNode.insertBefore(newReplacement, micBtn.nextSibling);
          }
          // Ha a mikrofont már hozzáadták, akkor azt is töröljük a tömbből
          if (selectedAccessoryIds.includes(micId)) {
            selectedAccessoryIds.splice(selectedAccessoryIds.indexOf(micId), 1);
            const micBtn = document.querySelector(`.add-accessory-btn[data-id='${micId}']`);
            if (micBtn) {
              micBtn.innerText = TNPP.t.add_btn;
              micBtn.disabled = false;
              micBtn.classList.remove("added");
            }
          }
        }
        return;
      }

      // Ha a felhasználó a "Külső mikrofon" gombjára kattint,
      // ellenőrizzük, hogy az RCA hozzá van-e adva.
      if (accessoryId === micId) {
        if (!selectedAccessoryIds.includes(rcaId)) {
          // Ha az RCA nincs kiválasztva, akkor ne tegyük lehetővé a hozzáadást.
          return;
        }
      }

      // Ha minden feltétel teljesül, hozzáadjuk az adott kiegészítőt:
      selectedAccessoryIds.push(accessoryId);
      this.innerText = TNPP.t.added_btn;
      this.disabled = true;
      this.classList.add("added");

      // Ha a hozzáadott kiegészítő az RCA,
      // akkor engedélyezzük a mikrofon gombját: eltüntetjük a helyettesítő divet és megjelenítjük a gombot.
      if (accessoryId === rcaId) {
        const micBtn = document.querySelector(`.add-accessory-btn[data-id='${micId}']`);
        if (micBtn) {
          micBtn.style.display = "inline-block";
        }
        const replacement = document.getElementById("mic-replacement");
        if (replacement) {
          replacement.remove();
        }
      }
    });
  });
});



    

  

/* ===== blokk 3 ===== */

document.addEventListener("DOMContentLoaded", function () {
        const e = document.querySelector(".buy-now-custom"),
            t = document.querySelector(".add-to-cart-with-accessories"),
            a = (document.querySelector(".product-accessories"), document.querySelectorAll(".cart-quantity[data-cart-count]")),
            r = document.querySelector('input[name="quantity"]'),
            o = document.querySelector(".cart-popup-wrapper"),
            n = document.querySelector(".cart-popup"),
            c = document.querySelector(".cart-popup-content"),
            i =
                (document.querySelector("[data-cart-popup-dismiss]"),
                document.querySelector("[data-cart-popup-close]"),
                document.getElementById("accessory-popup-overlay"),
                document.getElementById("close-popup"),
                document.getElementById("proceed-to-cart"),
                document.getElementById("skip-accessories"),
                []);
        function l(e, t) {
            e.preventDefault();
            const a = document.getElementById("selected-variant-id").getAttribute("data-selected-version");
            let r = null;
            if ("ALAP" === a) {
                const o = document.getElementById("upgrade-popup");
                if (o) {
                    o.classList.remove("hidden");
                    const n = o.querySelector("#upgrade-yes"),
                        c = o.querySelector("#upgrade-no");
                    return (
                        (n.onclick = function () {
                            o.classList.add("hidden");
                        }),
                        void (c.onclick = function () {
                            o.classList.add("hidden"), (r = document.getElementById("accessory-popup-overlay-alap")), (r.querySelector(".popup-title").textContent = a + (" " + TNPP.t.selection_excellent)), r.classList.remove("hidden");
                            const n = r.querySelector("#proceed-to-cart"),
                                c = r.querySelector("#skip-accessories");
                            (n.onclick = function () {
                                r.classList.add("hidden"), u(e, t);
                            })/*,
                                (c.onclick = async function (e) {
                                    e.preventDefault(), (i.length = 0), r.classList.add("hidden");
                                    try {
                                        await u(e, t),
                                            console.log("Fő termék sikeresen a kosárba került."),
                                            t &&
                                                setTimeout(() => {
                                                    (window.location.href = "/cart"), console.log("Átirányítás a kosár oldalra...");
                                                }, 1e3);
                                    } catch (e) {
                                        console.error("Hiba történt a 'Most kihagyom' funkcióban:", e), alert("Nem sikerült a terméket a kosárba adni.");
                                    }
                                })*/;
                        })
                    );
                }
                r = document.getElementById("accessory-popup-overlay-alap");
            } else if ("STANDARD" === a) r = document.getElementById("accessory-popup-overlay-alap");
            else {
                if ("PRO" !== a && "ELITE" !== a && "PRÉMIUM" !== a && "PRÉMIUM+" !== a) return void console.error(TNPP.t.alert_unknown_version + a);
                r = document.getElementById("accessory-popup-overlay-other");
            }
             (r.querySelector(".popup-title").textContent = a + (" " + TNPP.t.selection_excellent)), r.classList.remove("hidden");
            const o = r.querySelector("#proceed-to-cart"),
                n = r.querySelector("#skip-accessories"),
                step1Skip = r.querySelector(".skip-accessories-step-1"); // NEW: Step 1 Skip Link

            // Rename Button Text
            const btnText = o.querySelector(".btn-text");
            if(btnText) btnText.textContent = TNPP.t.add_to_cart_action;

            (o.onclick = function () {
                r.classList.add("hidden"), u(e, t);
            });
            
            // NOTE: Skip logic is now handled by the global delegated listener below
        }
        
        // --- GLOBAL DELEGATED SKIP LISTENER (Robust) ---
        // This ensures clicks are caught regardless of popup state or re-renders
        document.body.addEventListener('click', async function(e) {
            if (e.target && (e.target.id === 'skip-accessories' || e.target.classList.contains('skip-accessories-step-1'))) {
                e.preventDefault();
                e.stopPropagation();
                
                console.log("🚀 GLOBAL SKIP HANDLER TRIGGERED by:", e.target);
                
                // Clear accessories array globally
                i.length = 0;
                
                // Find visible popup to hide later (optional, u handles redirects)
                const visiblePopup = document.querySelector('.popup-overlay:not(.hidden)');
                
                try {
                    // Call the main addToCart function (u)
                    // We need 'u' to be accessible. Since 'u' is defined in this scope, it works!
                    // But we need the EVENT (e) and Boolean (t/isBuyNow)
                    // We passed 't' (add-to-cart-with-accessories) in the main scope.
                    
                    // Check if 'u' is available here. Yes, inside DOMContentLoaded.
                    
                    console.log("➡️ Calling u() with cleared accessories...");
                    const buyNowBtn = document.querySelector(".buy-now-custom"); // Approximate 't' check
                    const isBuyNow = false; // Usually false for this popup flow
                    const skipPopup = true; // NEW: Suppress popup for Skip action
                    
                    await u(e, isBuyNow, skipPopup);
                    
                    if(visiblePopup) visiblePopup.classList.add("hidden");
                    
                    console.log("✅ Skip process finished. Redirecting...");
                    window.location.href = "/cart";
                    
                } catch (err) {
                    console.error("❌ Hiba a global skip handlerben:", err);
                    alert(TNPP.t.alert_error_skip);
                }
            }
        });

        async function s(e, t, a, props = {}) {
            try {
                const body = { id: e, quantity: t };
                if (props && Object.keys(props).length > 0) {
                    body.properties = props;
                }
                const res = await fetch("/cart/add.js", { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(body) });
                
                // 1. Read text first to avoid JSON parse error on empty response
                const text = await res.text();
                let json = {};
                
                try {
                    json = text ? JSON.parse(text) : {};
                } catch (err) {
                    console.warn("Response was not JSON:", text);
                    // If OK but not JSON, maybe it worked? (e.g. 200 OK with empty body)
                }

                if(!res.ok) {
                    console.error("Fetch failed for:", e, json);
                    throw new Error(`Add failed: ${(json && json.description) || res.statusText || "Unknown Error"}`);
                }
                
                return json;
            } catch (e) {
                console.error(`Hiba a(z) ${a} kosárba tételekor:`, e);
                throw e;
            }
        }
        async function d(e, t) {
            let a = `\n        <div class="cart-popup-item">\n            <img src="${document
                .getElementById("selected-variant-id")
                .getAttribute(
                    "data-product-image"
                )}" alt="${e}" class="cart-popup-img">\n            <div class="cart-popup-details">\n                <strong class="cart-popup-name">${e}</strong>\n                <p class="cart-popup-message">${TNPP.t.in_cart_msg}</p>\n            </div>\n        </div>`;
            t.length > 0 &&
                ((a += '<ul class="cart-popup-accessories">'),
                t.forEach((e) => {
                    a += `<li class="cart-popup-accessory">+ ${e}</li>`;
                }),
                (a += "</ul>")),
                (c.innerHTML = a),
                o.classList.remove("cart-popup-wrapper--hidden"),
                setTimeout(() => {
                    o.classList.add("cart-popup-wrapper--hidden"), (c.innerHTML = "");
                }, 3e3);
        }
        async function u(e, t = !1, skipPopup = !1) {
            e.preventDefault();
            // JAVÍTÁS: Biztonságos darabszám lekérés
            const quantityInput = document.querySelector('input[name="quantity"]');
            const o = quantityInput ? Math.max(parseInt(quantityInput.value) || 1, 1) : 1;
            
            const n = (function () {
                const e = document.getElementById("selected-variant-id");
                if (e) {
                    const t = e.getAttribute("data-variant-id");
                    if (t) return parseInt(t);
                }
                return console.error("Nem található kijelölt variáció az elemben."), null;
            })();

            if (!n) return void alert(TNPP.t.alert_select_all);
            
            const c = (function () {
                const titleEl = document.querySelector(".product_shop .product-title");
                // Base title safely from Liquid if possible, or fallback to DOM
                let title = TNPP.productTitle || (titleEl ? titleEl.textContent.trim() : TNPP.t.fallback_product_title);
                
                // Append Variant Title if available
                if (n) {
                    try {
                        // 1. Try DOM lookup for specific variant item (best source)
                        const variantItem = document.querySelector(`.variant-item[data-variant-id="${n}"]`);
                        let vTitle = null;
                        
                        if (variantItem) {
                            vTitle = variantItem.getAttribute("data-variant-title");
                        }
                        
                        // 2. Fallback to centralized selection state
                        if (!vTitle) {
                             const sel = document.getElementById("selected-variant-id");
                             if(sel && sel.getAttribute("data-variant-id") == n){
                                 vTitle = sel.getAttribute("data-variant-title");
                             }
                        }
                        
                        // 3. Append if found and valid
                        if (vTitle && vTitle !== title && !vTitle.includes("Default Title")) {
                            title += ` ${vTitle}`;
                        }
                    } catch(e) { console.warn("Variant title lookup failed", e); }
                }

                return title;
            })();
            
            const l = []; 
            
            // Generate Unique ID for Strict Linking
            const uniqueID = Date.now() + Math.random().toString(36).substr(2, 9);
            
            try {
                // 1. Add Main Product
                let mainItemData;
                try {
                     const mainProps = { '_unique_id': uniqueID };
                     // 2026-10-09 (OKT10): az ajándék-megjegyzés ide is (ld. fent, data-okt10-giftnote)
                     try {
                         const gnEl2 = document.querySelector('form[action$="/cart/add"] [data-okt10-giftnote]');
                         const gnVid = document.querySelector('form[action$="/cart/add"] [name="id"]');
                         if (gnEl2 && gnEl2.value && (!gnVid || String(gnVid.value) === String(n) || document.getElementById('selected-variant-id'))) mainProps['HETVEGE10 ajándék'] = gnEl2.value;
                     } catch (gnErr2) { console.warn('[okt10-giftnote]', gnErr2); }
                    mainItemData = await s(n, o, c, mainProps);
                } catch(err) {
                    //alert("Nem sikerült a fő terméket a kosárba tenni: " + err.message);
                    return; 
                }
                
                // 2. Warranty Logic
                try {
                    const warrantyInput = document.querySelector('input[name="warranty_popup_add"]:checked');
                    if (warrantyInput && warrantyInput.value) {
                        const wId = parseInt(warrantyInput.value);
                        if (wId) {
                             const mainKey = mainItemData.key || mainItemData.items?.[0]?.key;
                             console.log("Adding Warranty:", wId, "Parent Key:", mainKey, "Calculated Title:", c);
                             
                             // FINAL SAFETY CHECK FOR TITLE
                             const finalTitle = (c && c.trim() !== "") ? c : TNPP.productTitle;

                             const wProps = { 
                                 '_warranty': 'true',
                                 '_parent_unique_id': uniqueID, // STRICT LINKING
                                 [TNPP.t.property_connected_product]: finalTitle // VISIBLE PROPERTY
                             };
                             if(mainKey) wProps['_parent_key'] = mainKey;
                             
                             console.log("Warranty Props:", wProps);

                             await s(wId, 1, TNPP.t.product_warranty, wProps); 
                             l.push(TNPP.t.product_warranty);
                             console.log("✅ Garancia hozzáadva.");
                        }
                    }
                } catch(err) {
                    console.error("Garancia hiba:", err);
                    alert(TNPP.t.alert_warranty_fail);
                }

                // 3. Accessories
                for (const e of i) {
                    const t = document.querySelector(`.add-accessory-btn[data-id='${e}']`);
                    if (t) {
                        const a = t.closest(".accessory-item").querySelector(".accessory-name").innerText;
                        await s(e, o, a), l.push(a);
                    }
                }

                // 3b. "Kérd hozzá csomagban" add-onok (product-addons.liquid) — 2026-08-27
                // Ez a legacy click-út preventDefault-ol, így a form submit (és az addon
                // snippet capture-fázisú interceptora) nem fut le; itt tesszük be őket.
                if (window.TN_ADDONS && typeof window.TN_ADDONS.getItems === 'function') {
                    for (const it of window.TN_ADDONS.getItems()) {
                        try {
                            const added = await s(it.id, it.quantity || 1, "add-on", it.properties || {});
                            l.push((added && (added.product_title || added.title)) || TNPP.t.addons_title);
                        } catch (err) {
                            console.error("Add-on hiba:", err);
                        }
                    }
                }

                // 4. Update cart count
                await (async function () {
                    try {
                        const e = await fetch("/cart.js");
                        if (!e.ok) throw new Error("Nem sikerült lekérni a kosár adatait.");
                        const t = (await e.json()).item_count;
                        a.forEach((e) => {
                            (e.textContent = t), e.setAttribute("data-cart-count", t);
                        });
                    } catch (e) {}
                })();

                // SHOW POPUP NOTIFICATION (d function)
                // Only show if NOT BuyNow AND NOT SkipPopup
                if (!t && !skipPopup) {
                     await d(c, l);
                }

                // REDIRECT
                // If BuyNow OR SkipPopup (implied by caller logic, but here explicit) -> Redirect
                if (t || skipPopup) {
                    // console.log("Direct redirect...");
                    // Caller might handle redirect, but standard 'u' behavior is to redirect if 't' is true.
                    // For skipPopup, we usually want redirect too.
                    // window.location.href = "/cart"; 
                    // Wait, existing logic was: t && (window.location.href = "/cart");
                    // We maintain that behavior for 't', but caller of skip usually handles its own redirect 
                    // OR we can do it here. The Global Skip Handler does its own redirect.
                    // So we just Don't show 'd'.
                }
                 
                if (t) window.location.href = "/cart";

            } catch (e) {
                console.error("Hiba történt a hozzáadás során:", e);
                throw e; // RETHROW to let caller handle it
            }
        }

        document.querySelectorAll(".add-accessory-btn").forEach((e) => {
            e.addEventListener("click", function () {
                const e = parseInt(this.getAttribute("data-id"));
                i.includes(e) || (i.push(e), (this.innerText = (" " + TNPP.t.added_btn)), (this.disabled = !0), this.classList.add("added"));
            });
        });

        // --- BUNDLE LISTENER ---
        document.querySelectorAll(".add-bundle-btn").forEach((btn) => {
            btn.addEventListener("click", function() {
                const ids = this.getAttribute("data-ids").split(',').map(id => parseInt(id));
                
                ids.forEach(id => {
                    if (!i.includes(id)) i.push(id);
                    // Update individual buttons
                    const indBtn = document.querySelector(`.add-accessory-btn[data-id="${id}"]`);
                    if(indBtn) {
                        indBtn.innerText = TNPP.t.btn_in_bundle;
                        indBtn.disabled = true;
                        indBtn.classList.add("added");
                    }
                });
                
                this.innerText = TNPP.t.btn_bundle_added;
                this.disabled = true;
                this.classList.add("added");
            });
        });
        // -----------------------
        const selectedVariant = document.getElementById("selected-variant-id");
        const p = selectedVariant && selectedVariant.getAttribute("data-selected-version")?.trim() !== "";
        a.length &&
            r &&
            o &&
            n &&
            c &&
            (t &&
                t.addEventListener("click", function (e) {
                    p ? l(e, !1) : u(e, !1);
                }),
                e && e.addEventListener("click", function (t) {
                    t.preventDefault(), p ? l(t, !0) : u(t, !0);
                })
            );
});

// Force Center Slides Fix (Added)
document.addEventListener('DOMContentLoaded', function() {
    setTimeout(function() {
        const swiperEl = document.querySelector('#accessory-popup-overlay-other .swiper-container');
        if (swiperEl && swiperEl.swiper) {
            swiperEl.swiper.params.centeredSlides = true;
            swiperEl.swiper.update();
            console.log("✅ Swiper centeredSlides forced by fix.");
        }
    }, 500);
});


/* ===== blokk 4 ===== */

document.addEventListener('DOMContentLoaded', function () {
    function getVariantIdFromUrl() {
        var currentUrl = window.location.pathname;
        var regex = /\/products\/.+\/(\d{14})$/;
        var match = currentUrl.match(regex);
        return match ? match[1] : null;
    }

    function updateAvailability() {
        let selectedVariantElement = document.getElementById('selected-variant-id');
        // Az airtable terméksablon más ID-kat használ, ezeknek a legacy elemeknek
        // a hiánya nem hiba — csak akkor manipuláljuk, ha léteznek.
        if (!selectedVariantElement) return;
        let priceContainer = document.getElementById('product-price-container');
        let priceLoader = document.getElementById('price-loader');
        let priceWrapper = document.querySelector('.price-wrapper');

        // Az árak elrejtése és a betöltő animáció megjelenítése (csak ha van mit)
        if (priceContainer) priceContainer.style.visibility = 'hidden';
        if (priceLoader) priceLoader.style.display = 'block';
        if (priceWrapper) priceWrapper.style.display = 'none';

        // Először az URL-ből próbáljuk meg kinyerni a variáció ID-t, ha nincs, akkor az eredeti érték marad
        let urlVariantId = getVariantIdFromUrl();
        let currentVariantId = selectedVariantElement.getAttribute('data-variant-id');

        if (urlVariantId && urlVariantId !== currentVariantId) {
            selectedVariantElement.setAttribute('data-variant-id', urlVariantId);
        }

        let selectedVariantId = selectedVariantElement.getAttribute('data-variant-id');
    
        let variants = document.querySelectorAll('#product-variants .variant-item');
        let availabilityContainer = document.getElementById('product-availability-container');
        let priceElement = document.querySelector('.current-price');
        let comparePriceElement = document.querySelector('.compare-price');

        let variantFound = false;

        variants.forEach(variant => {
            if (variant.getAttribute('data-variant-id') === selectedVariantId) {
                variantFound = true;
                let available = variant.getAttribute('data-variant-available') === "true";
                let price = variant.getAttribute('data-variant-price');
                let comparePrice = variant.getAttribute('data-variant-compare-price');
                let inventoryPolicy = variant.getAttribute('data-variant-inventory-policy');
                let inventoryQuantity = parseInt(variant.getAttribute('data-variant-inventory-quantity'));
                let variantTitle = variant.getAttribute('data-variant-title') || "";

                // Verzió meghatározása a variantTitle alapján (összehasonlításhoz nagybetűssé alakítjuk)
                let titleUpper = variantTitle.toUpperCase();
                let versionName = "";
                if (titleUpper.includes("1GB") && titleUpper.includes("16GB")) {
                    versionName = "ALAP";
                } else if (titleUpper.includes("2GB") && titleUpper.includes("32GB")) {
                    versionName = "STANDARD";
                } else if (titleUpper.includes("4GB") && titleUpper.includes("64GB")) {
                    versionName = "PRO";
                } else if (titleUpper.includes("6GB") && titleUpper.includes("128GB")) {
                    versionName = "ELITE";
                } else if (titleUpper.includes("8GB") && titleUpper.includes("128GB")) {
                    versionName = "PRÉMIUM";
                } else if (titleUpper.includes("8GB") && titleUpper.includes("256GB")) {
                    versionName = "PRÉMIUM+";
                }

                // A kiválasztott verzió frissítése a selectedVariantElement-ben
                selectedVariantElement.setAttribute("data-selected-version", versionName);

                // A data-variant-title attribútum is frissüljön a választásnak megfelelően
                // Ha a verzió alapján az értékek rögzítettek, akkor:
                let newVariantTitle = "";
                if (versionName === "ALAP") {
                    newVariantTitle = "1GB + 16GB ALAP";
                } else if (versionName === "STANDARD") {
                    newVariantTitle = "2GB + 32GB STANDARD";
                } else if (versionName === "PRO") {
                    newVariantTitle = "4GB + 64GB PRO";
                } else if (versionName === "ELITE") {
                    newVariantTitle = "6GB + 128GB ELITE";
                } else if (versionName === "PRÉMIUM") {
                    newVariantTitle = "8GB + 128GB PRÉMIUM";
                } else if (versionName === "PRÉMIUM+") {
                    newVariantTitle = "8GB + 256GB PRÉMIUM+";
                } else {
                    // Ha egyéb eset van, megtartjuk az eredeti címet
                    newVariantTitle = variantTitle;
                }
                selectedVariantElement.setAttribute("data-variant-title", newVariantTitle);

                // Árak frissítése az egyedi HTML struktúrában
                if (priceElement) {
                    priceElement.textContent = formatMoney(price) + " Ft";
                }
                if (comparePriceElement) {
                    if (comparePrice !== '0') {
                        comparePriceElement.textContent = formatMoney(comparePrice) + " Ft";
                        comparePriceElement.style.display = 'block';
                    } else {
                        comparePriceElement.style.display = 'none';
                    }
                }

                // Elérhetőség frissítése
                if (availabilityContainer) {
                    if (available && inventoryQuantity > 0) {
                        availabilityContainer.innerHTML = `
                            <span class="availability-icon"><svg class="tn-ico" viewBox="0 0 24 24" width="1em" height="1em" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><circle cx="12" cy="12" r="9"/><path d="M8.5 12.5 11 15l4.5-5"/></svg></span>
                            <span class="availability-text"><strong>${TNPP.t.stock_immediate}</strong></span>
                        `;
                        availabilityContainer.className = "availability-item in-stock";
                    } else if (available && inventoryPolicy === 'continue') {
                        availabilityContainer.innerHTML = `
                            <span class="availability-icon"><svg class="tn-ico" viewBox="0 0 24 24" width="1em" height="1em" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><circle cx="12" cy="12" r="9"/><path d="M12 7v5l3.2 1.9"/></svg></span>
                            <span class="availability-text"><strong>${TNPP.t.stock_limited}</strong></span>
                        `;
                        availabilityContainer.className = "availability-item limited-stock";
                    } else {
                        availabilityContainer.innerHTML = `
                            <span class="availability-icon"><svg class="tn-ico" viewBox="0 0 24 24" width="1em" height="1em" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><circle cx="12" cy="12" r="9"/><path d="M15 9l-6 6M9 9l6 6"/></svg></span>
                            <span class="availability-text">${TNPP.t.stock_none}</span>
                        `;
                        availabilityContainer.className = "availability-item out-of-stock";
                    }
                }
            }
        });

        if (!variantFound && availabilityContainer) {
            availabilityContainer.innerHTML = `
                <span class="availability-icon"><svg class="tn-ico" viewBox="0 0 24 24" width="1em" height="1em" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><circle cx="12" cy="12" r="9"/><path d="M12 7.5v5"/><circle cx="12" cy="16.2" r="0.9" fill="currentColor" stroke="none"/></svg></span>
                <span class="availability-text">${TNPP.t.stock_no_data}</span>
            `;
            availabilityContainer.className = "availability-item no-data";
        }

        // Az árak megjelenítése és a betöltő ikon eltüntetése a frissítés után
        if (priceLoader) priceLoader.style.display = 'none';
        if (priceWrapper) priceWrapper.style.display = 'block';
        if (priceContainer) priceContainer.style.visibility = 'visible';
    }

    // Ár formázó függvény (szóközös formátum, pl.: 127 990 Ft)
    function formatMoney(amount) {
        return amount.replace(/\B(?=(\d{3})+(?!\d))/g, " ");
    }

    // Figyeljük a kiválasztott variáció változását egyszeri frissítés után
    const selectedVariantElement = document.getElementById('selected-variant-id');
    let lastVariantId = selectedVariantElement ? selectedVariantElement.getAttribute('data-variant-id') : null;

    const observer = selectedVariantElement ? new MutationObserver(() => {
        let newVariantId = selectedVariantElement.getAttribute('data-variant-id');
        if (newVariantId !== lastVariantId) {
            lastVariantId = newVariantId;
            updateAvailability();
        }
    }) : null;
    
    // --- UPGRADE BUTTON LOGIC (Global Delegation) ---
    // Prevent duplicate listeners if this snippet is re-loaded
    if (!window.upgradeListenerAttached) {
        window.upgradeListenerAttached = true;
        
        document.body.addEventListener('click', function(e) {
            if (e.target && (e.target.id === 'upgrade-yes' || e.target.closest('#upgrade-yes'))) {
            e.preventDefault();
            console.log("🚀 Upgrade requested! Finding next tier...");
            
            // 1. Explicit Upgrade Path for ALAP Popup
            // User requested: ALAP -> STANDARD. If no STANDARD, then PRO.
            console.log("🚀 Upgrade requested! Looking for STANDARD, then PRO...");

            const swatches = Array.from(document.querySelectorAll('.swatch-element'));
            
            // Try STANDARD first
            let targetSwatch = swatches.find(s => {
                const v = s.getAttribute('version');
                return v && v.toUpperCase() === 'STANDARD';
            });
            
            // If not found, try PRO
            if (!targetSwatch) {
                console.log("STANDARD not found, trying PRO...");
                targetSwatch = swatches.find(s => {
                    const v = s.getAttribute('version');
                    return v && v.toUpperCase() === 'PRO';
                });
            }

            if (targetSwatch) {
                const ver = targetSwatch.getAttribute('version');
                console.log(`✅ Found target version: ${ver}. Clicking...`);
                
                let targetInput = targetSwatch.querySelector('input');
                if(!targetInput) targetInput = targetSwatch.querySelector('label');
                
                if(targetInput) {
                    targetInput.click();
                    
                     // 4. Close the popup
                    const popup = document.getElementById('upgrade-popup');
                    if(popup) {
                         popup.classList.add('hidden');
                    }
                }
            } else {
                console.error("❌ Could not find STANDARD or PRO version.");
                alert(TNPP.t.alert_unknown_version + " STANDARD/PRO");
            }
        }
        
        // Handle "No Thanks" button too
         if (e.target && (e.target.id === 'upgrade-no' || e.target.closest('#upgrade-no'))) {
             e.preventDefault();
             const popup = document.getElementById('upgrade-popup');
             if(popup) popup.classList.add('hidden');
         }
    });
    } // End of upgradeListenerAttached check

    if (observer && selectedVariantElement) {
        observer.observe(selectedVariantElement, { attributes: true });
    }

    // Első betöltéskor egyszer frissítünk
    updateAvailability();
});


/* ===== blokk 5 ===== */

/* ══════════════════════════════════════════════════════════════════
   AJÁNDÉK-LÉPÉS vezérlés (2026-07-23) — a kiegészítő-popup KÜLÖN oldala
   a garancia és a „válassz kiegészítőket" ELŐTT.

   Működés:
     · A popup megnyílásakor (a .hidden lekerül az overlayről) eldöntjük,
       kell-e a gift-lépés: kell, HA van terméklapi [data-ap-gift] gomb ÉS
       az még NEM .is-active (a vásárló még nem aktiválta az ajándékot).
     · Ha kell: a gift-lépés a normál tartalom (garancia-lépés / kiegészítő
       nézet) fölé kerül, azt elrejtjük — a vásárló ezt látja először.
     · „Aktiválom" → a terméklapi [data-ap-gift] gombot kattintja (az intézi
       a kosárba rakást + a FREEMIC kupont), rövid ✓ visszajelzés, majd
       továbblép a normál folyamatra.
     · „Most nem kérem, tovább" → aktiválás nélkül a normál folyamatra lép.
     · Ha az ajándék már aktív (a terméklapon aktiválták): a gift-lépés
       kimarad, egyből a szokásos popup jön.
   ══════════════════════════════════════════════════════════════════ */
(function () {
  var POPUP_IDS = ['accessory-popup-overlay-alap', 'accessory-popup-overlay-other'];

  function giftBtn() { return document.querySelector('[data-ap-gift]'); }

  function normalEls(popup) {
    if (popup.id === 'accessory-popup-overlay-other') {
      return [popup.querySelector('#popup-step-1'), popup.querySelector('#popup-step-2')]
        .filter(Boolean);
    }
    return [popup.querySelector('[data-alap-main]')].filter(Boolean);
  }

  function resetStepVisual(step) {
    step.classList.remove('is-done');
    delete step.dataset.pgBusy;
    var abtn = step.querySelector('[data-popup-gift-activate]');
    var atext = step.querySelector('[data-popup-gift-btn-text]');
    var eyebrow = step.querySelector('.pgs-eyebrow');
    if (abtn) abtn.disabled = false;
    if (atext) atext.textContent = 'Aktiválom az ajándékom';
    if (eyebrow) eyebrow.textContent = 'Ajándék jár a készülékhez';
  }

  function restore(popup, step) {
    step.classList.add('hidden');
    var els = step._restoreEls;
    if (!els || !els.length) {
      if (popup.id === 'accessory-popup-overlay-other') {
        var s1 = popup.querySelector('#popup-step-1');
        els = s1 ? [s1] : [];
      } else {
        var m = popup.querySelector('[data-alap-main]');
        els = m ? [m] : [];
      }
    }
    els.forEach(function (e) { e.classList.remove('hidden'); });
    step._restoreEls = null;
    // A kiegészítő-swiper eddig rejtett konténerben volt → méret-újraszámítás.
    try { window.dispatchEvent(new Event('resize')); } catch (e) {}
  }

  function markDone(step) {
    step.classList.add('is-done');
    var atext = step.querySelector('[data-popup-gift-btn-text]');
    var eyebrow = step.querySelector('.pgs-eyebrow');
    var abtn = step.querySelector('[data-popup-gift-activate]');
    if (atext) atext.textContent = 'Aktiválva — a kosárban';
    if (eyebrow) eyebrow.textContent = 'Sikeresen aktiváltad';
    if (abtn) abtn.disabled = true;
  }

  function showGiftStep(popup) {
    var step = popup.querySelector('[data-popup-gift-step]');
    if (!step) return;
    resetStepVisual(step);

    var b = giftBtn();
    var applicable = !!b && !b.classList.contains('is-active');

    if (!applicable) {
      // Nem kell a gift-lépés — rejtsük, és az alap popupnál mutassuk a fő nézetet.
      step.classList.add('hidden');
      if (popup.id === 'accessory-popup-overlay-alap') {
        var m = popup.querySelector('[data-alap-main]');
        if (m) m.classList.remove('hidden');
      }
      return;
    }

    // A jelenleg látható normál nézet(ek) elrejtése + a gift-lépés mutatása.
    var visible = normalEls(popup).filter(function (e) { return !e.classList.contains('hidden'); });
    step._restoreEls = visible.length ? visible : null;
    normalEls(popup).forEach(function (e) { e.classList.add('hidden'); });
    step.classList.remove('hidden');
    var sc = step.querySelector('.pgs-scroll');
    if (sc) sc.scrollTop = 0;
  }

  function bindStep(popup, step) {
    var activateBtn = step.querySelector('[data-popup-gift-activate]');
    var skipLink = step.querySelector('[data-popup-gift-skip]');

    if (skipLink) {
      skipLink.addEventListener('click', function (e) {
        e.preventDefault();
        restore(popup, step);
      });
    }

    if (activateBtn) {
      activateBtn.addEventListener('click', function () {
        if (step.dataset.pgBusy === '1') return;
        var b = giftBtn();
        if (!b) { restore(popup, step); return; }
        if (b.classList.contains('is-active')) {
          markDone(step);
          setTimeout(function () { restore(popup, step); }, 1100);
          return;
        }
        step.dataset.pgBusy = '1';
        activateBtn.disabled = true;
        var atext = step.querySelector('[data-popup-gift-btn-text]');
        if (atext) atext.textContent = 'Aktiválás…';

        var done = false;
        var obs = new MutationObserver(function () {
          if (b.classList.contains('is-active') && !done) {
            done = true;
            obs.disconnect();
            markDone(step);
            setTimeout(function () { restore(popup, step); }, 1300);
          }
        });
        obs.observe(b, { attributes: true, attributeFilter: ['class'] });
        b.click();

        // Fallback: ha az aktiválás valamiért nem áll be, továbblépünk.
        setTimeout(function () {
          if (!done) { done = true; obs.disconnect(); restore(popup, step); }
        }, 4500);
      });
    }
  }

  POPUP_IDS.forEach(function (id) {
    var popup = document.getElementById(id);
    if (!popup) return;
    var step = popup.querySelector('[data-popup-gift-step]');
    if (!step) return; // Az ajándék nem aktív ezen a terméken → nincs gift-lépés.

    bindStep(popup, step);

    var wasVisible = !popup.classList.contains('hidden');
    new MutationObserver(function () {
      var vis = !popup.classList.contains('hidden');
      if (vis && !wasVisible) showGiftStep(popup); // épp most nyílt meg
      wasVisible = vis;
    }).observe(popup, { attributes: true, attributeFilter: ['class'] });
  });
})();

/* ===== görgetészár + párbeszédablak-fókusz a kosárba tétel utáni popupokhoz (2026-09-15 / 09-23 a11y-2).
   Korábban inline a snippet végén; a snippet csonkja hívja DOMContentLoaded-kor, a 2. blokk után. ===== */
window.__tnPopLockRun = function () {
  if (window.__tnPopLock) return;
  window.__tnPopLock = true;
  var IDS = ['accessory-popup-overlay-alap', 'accessory-popup-overlay-other', 'upgrade-popup', 'q7-mmi2g-decoder-popup'];
  var CLOSABLE = []; // 2026-09-15: a tulaj kérésére egyik sem zárható be
  var locked = false, savedY = 0;
  function isOpen(el) { return !!el && !el.classList.contains('hidden') && el.style.display !== 'none' && getComputedStyle(el).display !== 'none'; }
  function anyOpen() { return IDS.some(function (id) { return isOpen(document.getElementById(id)); }); }
  function lock() {
    if (locked) return;
    locked = true;
    savedY = window.scrollY || window.pageYOffset || 0;
    document.documentElement.classList.add('tn-pop-locked');
    var b = document.body.style;
    b.position = 'fixed'; b.top = (-savedY) + 'px'; b.left = '0'; b.right = '0'; b.width = '100%';
  }
  function unlock() {
    if (!locked) return;
    locked = false;
    document.documentElement.classList.remove('tn-pop-locked');
    var b = document.body.style;
    b.position = ''; b.top = ''; b.left = ''; b.right = ''; b.width = '';
    window.scrollTo(0, savedY);
  }
  /* 2026-09-23 (a11y-audit a11y-2): párbeszédablakként viselkedjen — nyitáskor a fókusz az ablakba kerül,
     a háttér (az ablak ősláncának összes TESTVÉRE) inert, így Tab és képernyőolvasó az ablakban marad.
     Ős-elem SOHA nem kap inert-et (az öröklődik, az ablak is halott lenne). Váltáskor (Q7-dekóder →
     kiegészítő, verzióváltó → alap) ELŐBB release(): a 4 ablak testvér, az előző lista az újat is tartalmazza.
     Bezárhatóság változatlan (tulajdonosi döntés: nincs ×/Esc/háttér). */
  var cur = null, inerted = [], stepObs = null;
  function openEl() { for (var i = 0; i < IDS.length; i++) { var e = document.getElementById(IDS[i]); if (isOpen(e)) return e; } return null; }
  function release() { inerted.forEach(function (n) { n.inert = false; }); inerted = []; }
  function isolate(el) {
    release();
    var n = el;
    while (n && n !== document.body) {
      var p = n.parentElement;
      if (!p) break;
      Array.prototype.forEach.call(p.children, function (s) {
        if (s !== n && !s.inert && !/^(SCRIPT|STYLE|LINK|TEMPLATE|NOSCRIPT)$/.test(s.tagName)) { s.inert = true; inerted.push(s); }
      });
      n = p;
    }
  }
  function focusStart(el) {
    var box = el.querySelector('.popup-content') || el;
    var hs = box.querySelectorAll('[role="heading"]'), t = box;
    for (var i = 0; i < hs.length; i++) { if (hs[i].getClientRects().length) { t = hs[i]; break; } }
    if (!t.hasAttribute('tabindex')) t.setAttribute('tabindex', '-1');
    t.style.outline = 'none';
    try { t.focus({ preventScroll: true }); } catch (x) { t.focus(); }
  }
  function sync() {
    var el = openEl();
    if (el) lock(); else unlock();
    if (el === cur) return;
    var prev = cur;
    cur = el;
    if (stepObs) { stepObs.disconnect(); stepObs = null; }
    if (el) {
      isolate(el);
      focusStart(el);
      /* lépésváltás (garancia → kiegészítők, vissza, ajándék): ha a fókuszált elem eltűnik, a látható lépés címére ugrik */
      stepObs = new MutationObserver(function () {
        setTimeout(function () {
          var a = document.activeElement;
          if (cur && (!a || a === document.body || !cur.contains(a) || !a.getClientRects().length)) focusStart(cur);
        }, 0);
      });
      stepObs.observe(el, { subtree: true, attributes: true, attributeFilter: ['class', 'style', 'hidden'] });
    } else {
      release();
      var a = document.activeElement;
      if (prev && (!a || a === document.body || prev.contains(a))) { var b = document.querySelector('.ap-atc'); if (b) b.focus({ preventScroll: true }); }
    }
  }
  function close(el) {
    el.classList.add('hidden');
    if (el.id === 'upgrade-popup') el.style.display = 'none';
    sync();
  }
  function init() {
    var obs = new MutationObserver(function () { setTimeout(sync, 0); });
    IDS.forEach(function (id) {
      var el = document.getElementById(id);
      if (!el) return;
      obs.observe(el, { attributes: true, attributeFilter: ['class', 'style'] });
      if (CLOSABLE.indexOf(id) === -1) return;
      var btn = el.querySelector('.close-btn');
      if (btn) {
        btn.classList.remove('hidden');
        btn.setAttribute('type', 'button');
        btn.setAttribute('aria-label', 'Bezárás');
        btn.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); close(el); }, true);
      }
      el.addEventListener('click', function (e) { if (e.target === el) close(el); });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      CLOSABLE.forEach(function (id) { var el = document.getElementById(id); if (isOpen(el)) close(el); });
    });
    sync();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
};
